import { BulbOutlined, CloseOutlined } from "@ant-design/icons";
import {
  EAgentToolType,
  EAiActionStatus,
  EAiModelStatus,
  ECrewAiAgentMemoryMode,
  EDatasourceType,
  EOpenAIUserRole,
  ESdChangeReason,
  IActionDefinitionDto,
  IAgentChatResponseDTO,
  IAiAgentModel,
  IAiAgentTemplate,
  ICrewAgent,
  ICrewAgentDTO,
  ICrewAgentTask,
  ICrewAgentTool,
  ICrewCustomDataType,
  ICrewInput,
  ICrewManagerAgent,
  ICrewMemoryOptions,
  IDatasourceDto,
  IGenerateAgentRequestDTO,
  IOpenAICodeGeneratorMessageDTO
} from "@kuika/kuika-cl-model";
import { Form, FormInstance } from "antd/es";
import classNames from "classnames";
import { Guid } from "guid-typescript";
import _ from "lodash";
import ObjectHash from "object-hash";
import { createRef, KeyboardEvent as ReactKeyboardEvent, ReactNode } from "react";
import { connect } from "react-redux";
import ReactFlow, { applyNodeChanges, Background, MiniMap, NodeChange, ReactFlowInstance } from "reactflow";
import "../../../blockly/index";
import { ConfigService } from "../../../services/config-service";
import { DatasourceService } from "../../../services/datasource-service";
import { OpenAIService } from "../../../services/openai-service";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { SaveStatus } from "../../../shared/utility/save-status";
import { AppState } from "../../../store/root-reducer";
import { setNextCallbackFunction, setShowModal } from "../../../store/unsaved-changes-modal/actions";
import { runParkedNavigation } from "../../../store/unsaved-changes-modal/run-parked-navigation";
import { KuikaChatBot } from "../../common/ai/kuika-chatbot/kuika-chatbot";
import CloseConfirmationModal from "../../common/close-confirmation-modal";
import { DeleteModal } from "../../common/delete-modal";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import KuikaBadge from "../../ui-kit/kuika-badge/kuika-badge";
import KuikaButton, { type KuikaButtonStatus } from "../../ui-kit/kuika-button/kuika-button";
import KuikaInput from "../../ui-kit/kuika-input/kuika-input";
import {
  KuikaCreateCard,
  KuikaCreateCardRow,
  KuikaListPageHeader,
  KuikaListPageToolbar
} from "../../ui-kit/kuika-list-page/kuika-list-page";
import KuikaListTable, {
  KuikaListTableColumn,
  KuikaListTableNameCell,
  KuikaListTableStatusCell,
  KuikaListTableUserCell
} from "../../ui-kit/kuika-list-table/kuika-list-table";
import { KuikaEditorTitle } from "../../ui-kit/kuika-page-header/kuika-editor-title";
import KuikaPageHeader from "../../ui-kit/kuika-page-header/kuika-page-header";
import KuikaSpinnerSmall from "../../ui-kit/kuika-spinner-small/kuika-spinner-small";
import KuikaSplitButton from "../../ui-kit/kuika-split-button/kuika-split-button";
import "./editor-bar-surface.scss";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaSwitch from "../../ui-kit/kuika-switch/kuika-switch";
import KuikaTabContent from "../../ui-kit/kuika-tab-content/kuika-tab-content";
import KuikaTabs from "../../ui-kit/kuika-tabs/kuika-tabs";
import KuikaTooltip from "../../ui-kit/kuika-tooltip/kuika-tooltip";
import {
  ICommonConfigDeleteFunctionParams,
  ICommonConfigSaveFunctionParams
} from "../app-settings/app-settings-config-manager/app-settings-config-container";
import { ConfigApifySettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-apify";
import { ConfigBraveSearchSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-brave-search";
import { ConfigDropboxSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-dropbox";
import { ConfigFirecrawlMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-firecrawl";
import { ConfigGithubSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-github";
import { ConfigGoogleMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-google-mcp";
import { ConfigGoogleMapMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-google-mcp-map";
import { ConfigJiraMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-jira";
import { ConfigOffice365McpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-ofice-365-mcp";
import { ConfigSlackSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-slack";
import { ConfigTrelloMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-trello";
import { ConfigYoutubeMcpSettings } from "../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-youtube";
import { AiAgentCustomDataTypesModal } from "./ai-agent/ai-agent-custom-data-types-modal";
import ElkNode from "./ai-agent/ai-agent-elk-node";
import {
  AGENT_TOOLS,
  actionToToolOption,
  buildAIAgentFlowWithProcessType,
  generateAIAgentNodesAndEdges,
  IAiAgentManagerNodeData,
  ElkNode as IElkNode
} from "./ai-agent/ai-agent-helper";
import { AiAgentInputsModal } from "./ai-agent/ai-agent-inputs-modal";
import AIAgentManagerNode from "./ai-agent/ai-agent-manager-node";
import { AIAgentMcpModal } from "./ai-agent/ai-agent-mcp-modal";
import { AiAgentResponseModal } from "./ai-agent/ai-agent-response-modal";
import AIAgentSidebar from "./ai-agent/ai-agent-sidebar";
import { AiAgentTestModal } from "./ai-agent/ai-agent-test-modal";
import AiModelDeprecationBanners from "./ai-model-deprecation-banners";
import AIActionTemplates from "./ai/ai-action-templates";
import "./ai-agent/ai-agent.scss";
import CreateScratchEmptyState from "./common/create-scratch-empty-state/create-scratch-empty-state";
import SharedReactFlowControls from "./common/react-flow-controls/react-flow-controls";
import "./ai/ai-action.scss";
import { requestDatasourceReveal } from "./datasource-reveal";
import { AiActionSwitcherChip } from "./editor-switcher/ai-action-switcher-chip";

type ViewMode = "edit" | "preview";
type RightPanelTab = "chat" | "params";
type CrewProcessType = "sequential" | "hierarchical";
const PROCESS_TYPE_TO_NUMBER: Record<CrewProcessType, number> = { sequential: 0, hierarchical: 1 };
const PROCESS_TYPE_FROM_NUMBER: Record<number, CrewProcessType> = { 0: "sequential", 1: "hierarchical" };
const AI_AGENT_PALETTE_DRAG_TYPE = "application/kuika-ai-agent-palette";

type WalkthroughPlacement = "center" | "canvas" | "manager" | "workers" | "connections" | "sidebar" | "actions";

interface IProcessTypeWalkthroughStep {
  id: string;
  stepLabel: string;
  title: string;
  description: string;
  placement: WalkthroughPlacement;
  highlightSelector?: string;
}

interface IAgentHistorySnapshot {
  nodes: IElkNode[];
  edges: any[];
  crew_inputs: ICrewInput[];
  crew_custom_data_types?: ICrewCustomDataType[];
  processType: CrewProcessType;
  managerAgent?: ICrewManagerAgent;
  crewMemoryOptions?: ICrewMemoryOptions;
  conversationHistoryEnabled: boolean;
}

interface IStarterAgentFlowData {
  agents: ICrewAgent[];
  crewInputs: ICrewInput[];
  crewCustomDataTypes: ICrewCustomDataType[];
  managerAgent?: ICrewManagerAgent;
}

interface ICreateAIAgentActionState {
  isNameOnEdit: boolean;
  actionName: string;
  /** Dims the canvas — for the save and for every agent/tool fetch that shares it. */
  isSaveDisabled: boolean;
  /** Where the agent's commit stands. Owned by `SaveStatus`, never set directly. */
  saveStatus: KuikaButtonStatus;
  nodes: IElkNode[];
  edges: any[];
  chatbotMessages: IOpenAICodeGeneratorMessageDTO[];
  crew_inputs: ICrewInput[];
  showResponseModal: boolean;
  showManagerResponseModal: boolean;
  showInputsModal: boolean;
  showCustomTypesModal: boolean;
  showTestModal: boolean;
  selectedAgentId?: string;
  crew_custom_data_types?: ICrewCustomDataType[];
  processType: CrewProcessType;
  managerAgent?: ICrewManagerAgent;
  // Crew-level memory options -- currently only the `embedder` config is
  // user-editable from the sidebar. Persists to CrewInfoModel.MemoryOptions.
  crewMemoryOptions?: ICrewMemoryOptions;
  selectedTemplateId?: string;
  selectedFrameworkIds: string[];
  isCreatingCustomTemplate: boolean;
  agentModels: IAiAgentModel[];
  agentTemplates: IAiAgentTemplate[];
  isTemplatesLoading: boolean;
  submitButtonDisabledStatus: boolean;
  mcpModalIndexes?: { nodeId: string; toolIndex: number };
  // KOA-16736: actionId of the KAction tool node clicked on the workflow canvas
  // — drives the sidebar's "alone" detail view (renderKActionDetailView).
  activeKActionId?: string | null;
  mcpConfigModalVisibility: {
    [key: string]: { editingId?: string; visibility?: boolean };
  };
  searchTerm: string;
  selectedTags: string[];
  viewMode: ViewMode;
  rightPanelTab: RightPanelTab;
  hasManualChanges: boolean;
  isFixingAgents: boolean;
  showFixesAppliedModal: boolean;
  undoStack: IAgentHistorySnapshot[];
  redoStack: IAgentHistorySnapshot[];
  isCreatingFromTemplate: boolean;
  activeTab: "templates" | "recents";
  recentsMenuId: string | null;
  recentsMenuPosition: { top: number; left: number } | null;
  actionToDelete?: IActionDefinitionDto;
  isDeleteActionModalVisible: boolean;
  isScratchSidebarVisible: boolean;
  isScratchEmptyStateVisible: boolean;
  showProcessTypeSelectionModal: boolean;
  pendingCustomProcessType: CrewProcessType | undefined;
  isMiniMapVisible: boolean;
  isCanvasPanEnabled: boolean;
  showProcessTypeWalkthrough: boolean;
  processTypeWalkthroughSteps: IProcessTypeWalkthroughStep[];
  processTypeWalkthroughStepIndex: number;
  processTypeWalkthroughSpotlight?: {
    top: number;
    left: number;
    right: number;
    bottom: number;
  };
  walkthroughPreferredAccordionKey?: string;
  showManagerFlowMsg: boolean;
  showSequentialFlowMsg: boolean;
  isManagerSelected: boolean;
  autoFixEnabled: boolean;
  conversationHistoryEnabled: boolean;
}
interface ICreateAIAgentActionProps {
  actionDatasource: IDatasourceDto;
  actionToEdit?: IActionDefinitionDto;
  showModal: boolean;
  nextCallback?: () => void;
  setShowModal: (boolean) => void;
  setNextCallbackFunction: (cb?: () => void) => void;
}

/** The landing tabs in their on-screen order, so a switch slides towards the one chosen. */
const AI_AGENT_TAB_ORDER: string[] = ["templates", "recents"];

class CreateAIAgentAction extends PureSdComponent<ICreateAIAgentActionProps & IWithSDProps, ICreateAIAgentActionState> {
  formRef = createRef<FormInstance>();

  chatbotMessagesContainerRef = createRef<HTMLDivElement>();

  chatbotRef = createRef<KuikaChatBot>();

  objectHash: string = "";

  private readonly saveStatus: SaveStatus = new SaveStatus((saveStatus: KuikaButtonStatus): void => {
    this.setState({ saveStatus });
  });

  sessionId: string = "";

  reactFlowInstance?: ReactFlowInstance;

  // Stable reference to prevent ReactFlow from remounting all nodes on every parent re-render.
  // The inner arrow functions read from `this.state` at invocation time, so the latest values
  // are always used — we only need the OBJECT reference and the component identities to be stable.
  private readonly reactFlowNodeTypes = {
    elk: (props: any) => (
      <ElkNode
        {...props}
        onAddAgentAfter={() => this.handleAddAgentAfter(props.id)}
        updateTools={(tools) => {
          this.updateNodeTool(props.id, tools);
        }}
        readOnly={this.state.viewMode === "preview"}
        processType={this.state.processType}
        updateName={(name) => {
          this.updateNodeName(props.id, name);
        }}
        updateModel={(model) => {
          this.updateModel(props.id, model);
        }}
        updateMemory={(memory) => {
          this.updateMemory(props.id, memory);
        }}
        onRemoveNode={() => void this.removeNode(props.id)}
        onCopyNode={() => void this.copyNode(props.id)}
        onOpenMcpConfig={(toolIndex) => this.handleOpenMcpModal(props.id, toolIndex)}
        onToolClick={() => {
          this.selectNode(props.id);
          this.setState((prev) => ({
            isManagerSelected: false,
            rightPanelTab: "params",
            walkthroughPreferredAccordionKey: prev.walkthroughPreferredAccordionKey === "tools" ? "tools_" : "tools"
          }));
        }}
        kActionOptions={this.getAvailableKActions().map((a) => actionToToolOption(a))}
        kActionTools={(props.data?.metadata?.tools ?? []).filter(
          (t: ICrewAgentTool) => t.toolType === EAgentToolType.KAction
        )}
        updateKActionTools={(kTools: ICrewAgentTool[]) => {
          const allTools = props.data?.metadata?.tools ?? [];
          const regularTools = allTools.filter((t: ICrewAgentTool) => t.toolType !== EAgentToolType.KAction);
          this.updateNodeTool(props.id, [...regularTools, ...kTools]);
        }}
        onActionClick={(actionId: string | undefined) => {
          // KOA-16736: Open the KAction detail view "alone" in the right sidebar
          // (replaces the whole accordion area, mirrors the MCP tool config pattern).
          this.selectNode(props.id);
          this.setState({
            isManagerSelected: false,
            rightPanelTab: "params",
            activeKActionId: actionId ?? null
          });
        }}
      />
    ),
    manager: (props: any) => <AIAgentManagerNode {...props} />
  };

  highlightedWalkthroughElements: Element[] = [];

  scratchFeatures: string[] = [
    "Automate multi-step workflows",
    "Connect with tools and data sources",
    "Define decision logic and behaviors",
    "Coordinate multiple AI actions"
  ];

  constructor(props: ICreateAIAgentActionProps & IWithSDProps) {
    super(props);

    this.state = {
      isNameOnEdit: false,
      actionName: "",
      isSaveDisabled: false,
      saveStatus: "idle",
      nodes: [],
      edges: [],
      chatbotMessages: [],
      crew_inputs: [],
      crew_custom_data_types: [],
      processType: "sequential",
      managerAgent: undefined,
      crewMemoryOptions: undefined,
      showResponseModal: false,
      showManagerResponseModal: false,
      showInputsModal: false,
      showCustomTypesModal: false,
      showTestModal: false,
      selectedFrameworkIds: [],
      isCreatingCustomTemplate: !!props.actionToEdit?.aiAgentInfo,
      agentModels: [],
      agentTemplates: [],
      isTemplatesLoading: !!props.actionToEdit?.aiAgentInfo,
      submitButtonDisabledStatus: true,
      mcpConfigModalVisibility: {},
      searchTerm: "",
      selectedTags: [],
      viewMode: "edit",
      rightPanelTab: "chat",
      hasManualChanges: false,
      isFixingAgents: false,
      showFixesAppliedModal: false,
      undoStack: [],
      redoStack: [],
      isCreatingFromTemplate: false,
      activeTab: "templates",
      recentsMenuId: null,
      recentsMenuPosition: null,
      actionToDelete: undefined,
      isDeleteActionModalVisible: false,
      isScratchSidebarVisible: false,
      isScratchEmptyStateVisible: false,
      showProcessTypeSelectionModal: false,
      pendingCustomProcessType: "sequential",
      isMiniMapVisible: true,
      isCanvasPanEnabled: true,
      showProcessTypeWalkthrough: false,
      processTypeWalkthroughSteps: [],
      processTypeWalkthroughStepIndex: 0,
      processTypeWalkthroughSpotlight: undefined,
      walkthroughPreferredAccordionKey: undefined,
      showManagerFlowMsg: true,
      showSequentialFlowMsg: true,
      autoFixEnabled: false,
      isManagerSelected: false,
      conversationHistoryEnabled: false
    };
  }

  toggleRecentsMenu = (event: React.MouseEvent<HTMLButtonElement>, menuId: string) => {
    event.stopPropagation();

    if (this.state.recentsMenuId === menuId) {
      this.setState({ recentsMenuId: null, recentsMenuPosition: null });
      return;
    }

    const triggerRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    const menuWidth = 100;
    const menuItemHeight = 32;
    const menuVerticalPadding = 8;
    const menuHeight = 2 * menuItemHeight + menuVerticalPadding;
    const offset = 4;
    const viewportPadding = 8;

    const spaceBelow = viewportHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;

    let top = triggerRect.bottom + offset;
    if (spaceBelow < menuHeight + offset && spaceAbove >= menuHeight + offset) {
      top = triggerRect.top - menuHeight - offset;
    } else if (spaceBelow < menuHeight + offset && spaceAbove < menuHeight + offset) {
      top = Math.max(viewportPadding, viewportHeight - menuHeight - viewportPadding);
    }

    const left = Math.max(
      viewportPadding,
      Math.min(triggerRect.right - menuWidth, viewportWidth - menuWidth - viewportPadding)
    );

    this.setState({
      recentsMenuId: menuId,
      recentsMenuPosition: { top, left }
    });
  };

  componentWillUnmount() {
    this.saveStatus.dispose();
    this.clearProcessTypeWalkthroughHighlight(false);
    window.removeEventListener("beforeunload", this.handleUnload);
    document.removeEventListener("keydown", this.handleWorkflowUndoRedoShortcut);
  }

  async componentDidMount() {
    window.addEventListener("beforeunload", this.handleUnload);
    document.addEventListener("keydown", this.handleWorkflowUndoRedoShortcut);
    await this.handleLoadAIAgent();
  }

  componentDidUpdate(prevProps: ICreateAIAgentActionProps & IWithSDProps) {
    if (
      this.props.actionDatasource?.id !== prevProps.actionDatasource?.id ||
      this.props.actionToEdit !== prevProps.actionToEdit
    ) {
      if (this.sessionId) {
      }
      this.handleLoadAIAgent();
    }
    // A save the pending navigation asked for ("Update & close") is still running or showing
    // its ✓: its own close runs the navigation. Asking again now would re-open the confirmation.
    if (this.props.nextCallback && this.saveStatus.canStart) {
      this.handleCloseDatasource();
    }
  }

  generateDefaultAgentName = (): string => {
    const baseName = "AI_Agent";
    const existingNames = new Set(
      this.props.sd.actionDefinitions
        ?.filter((a) => a.actionType === EDatasourceType.AIAgent)
        .map((a) => a.name?.toLocaleLowerCase()) ?? []
    );
    let counter = 1;
    while (existingNames.has(`${baseName}${counter}`.toLocaleLowerCase())) {
      counter++;
    }
    return `${baseName}${counter}`;
  };

  handleLoadAIAgent = async () => {
    const {
      actionToEdit,
      sd: { activeCreatingActionName }
    } = this.props;
    // The whole load lands in ONE setState at the end, so the `isTemplatesLoading`
    // flag written on the local draft below never reaches React while the fetch is
    // in flight — the gallery sat on its initial `false` and rendered "No templates
    // found" instead of the skeletons AI Actions shows. Flip it in real state first;
    // the batched setState at the end clears it.
    this.setState({ isTemplatesLoading: true });
    let state = { ..._.cloneDeep(this.state) };
    const defaultName = actionToEdit ? activeCreatingActionName || "" : this.generateDefaultAgentName();
    state.actionName = defaultName;
    state.isNameOnEdit = false;
    state.chatbotMessages = [];
    state.crew_inputs = [];
    state.crew_custom_data_types = [];
    state.processType = "sequential";
    state.managerAgent = undefined;
    state.crewMemoryOptions = undefined;
    state.conversationHistoryEnabled = false;
    state.selectedTemplateId = undefined;
    state.nodes = [];
    state.edges = [];
    state.isCreatingCustomTemplate = false;
    state.isTemplatesLoading = true;
    state.submitButtonDisabledStatus = true;
    state.showProcessTypeWalkthrough = false;
    state.processTypeWalkthroughSteps = [];
    state.processTypeWalkthroughStepIndex = 0;

    this.sessionId = actionToEdit?.id || Guid.create().toString();

    state.showManagerFlowMsg = !localStorage.getItem(`kuika-ai-agent-manager-msg-dismissed-${this.sessionId}`);
    state.showSequentialFlowMsg = !localStorage.getItem(`kuika-ai-agent-sequential-msg-dismissed-${this.sessionId}`);

    const formValues = {
      name: defaultName
    };

    if (actionToEdit?.aiAgentInfo) {
      let dto: ICrewAgentDTO = JSON.parse(actionToEdit.aiAgentInfo);

      // Migration: Convert old nested params structure to new flat structure
      if (dto.crewAgents) {
        dto.crewAgents = dto.crewAgents.map((agent) => {
          if (agent.task && (agent.task as any).params) {
            const oldParams = (agent.task as any).params;
            // Move params properties directly onto task (use correct property name for backend)
            if (oldParams.guardrail !== undefined) agent.task.guardrail = oldParams.guardrail;
            if (oldParams.guardrail_max_retries !== undefined)
              agent.task.guardrailMaxRetryLimit = oldParams.guardrail_max_retries;
            if (oldParams.guardrailMaxRetryLimit !== undefined)
              agent.task.guardrailMaxRetryLimit = oldParams.guardrailMaxRetryLimit;
            if (oldParams.markdown !== undefined) agent.task.markdown = oldParams.markdown;
            if (oldParams.human_input !== undefined) agent.task.human_input = oldParams.human_input;
            if (oldParams.async_execution !== undefined) agent.task.async_execution = oldParams.async_execution;
            // Remove the old params object
            delete (agent.task as any).params;
          }
          // Migration: legacy boolean `memory` → `memoryMode` enum
          if (agent.memoryMode === undefined && typeof (agent as any).memory === "boolean") {
            agent.memoryMode = (agent as any).memory ? ECrewAiAgentMemoryMode.Shared : ECrewAiAgentMemoryMode.Disabled;
          }
          delete (agent as any).memory;
          return agent;
        });
      }

      // Handle backwards compatibility: if aiAgentInfo only has templateId (old format),
      // fetch the full agent data from the template
      if (dto.templateId && (!dto.crewAgents || dto.crewAgents.length === 0)) {
        // Load templates to get the full agent data
        const templatesResult = await this.getTemplates();
        const templates = templatesResult?.data ?? [];
        const template = templates.find((t: IAiAgentTemplate) => t.id === dto.templateId);

        if (template?.agentModel) {
          // Parse the template's agentModel to get the full agent data
          const templateData =
            typeof template.agentModel === "string" ? JSON.parse(template.agentModel) : template.agentModel;
          dto = {
            ...templateData,
            templateId: dto.templateId
          };
        }
      }

      // KOA-14774 legacy hierarchical migration (applied at load time).
      // Old shape: `managerAgent` was saved as a bare name string referring to one of the
      //            agents in `crewAgents`. Each sub-agent could own a `task`/`memoryMode`.
      // New shape: `managerAgent` is a full object (name/role/goal/backstory/task/...) at
      //            the top level; sub-agents are pure capability profiles with no task.
      // This block detects the old shape and rewrites the DTO in memory so the rest of
      // the load path (and the save-time validator) see only the new shape.
      const loadedProcessType = this.normalizeProcessType((dto as any).processType ?? (dto as any).process_type);
      if (loadedProcessType === "hierarchical" && Array.isArray(dto.crewAgents)) {
        const rawManager = (dto as any).managerAgent ?? (dto as any).manager_agent;
        const managerNameRef: string | undefined =
          typeof rawManager === "string"
            ? rawManager.trim()
            : rawManager && typeof rawManager === "object"
              ? (rawManager as { name?: unknown }).name?.toString().trim()
              : undefined;

        if (managerNameRef) {
          const managerIdx = dto.crewAgents.findIndex((a) => a?.name?.trim() === managerNameRef);
          if (managerIdx >= 0) {
            // Promote the legacy manager-in-crewAgents into a full managerAgent object.
            // Prefer fields already present on rawManager (if any); fall back to the
            // matched sub-agent so role/goal/backstory/task carry forward.
            const matched = dto.crewAgents[managerIdx];
            const rawMgrObj = (typeof rawManager === "object" ? rawManager : {}) as Record<string, unknown>;
            const promoted: ICrewManagerAgent = {
              name: managerNameRef,
              role: typeof rawMgrObj.role === "string" ? rawMgrObj.role : matched.role,
              goal: typeof rawMgrObj.goal === "string" ? rawMgrObj.goal : matched.goal,
              backstory: typeof rawMgrObj.backstory === "string" ? rawMgrObj.backstory : matched.backstory,
              model: (rawMgrObj.model as any) ?? matched.model,
              tools: (rawMgrObj.tools as ICrewAgentTool[]) ?? matched.tools,
              memoryMode:
                typeof rawMgrObj.memoryMode === "number"
                  ? (rawMgrObj.memoryMode as ECrewAiAgentMemoryMode)
                  : matched.memoryMode,
              task: (rawMgrObj.task as ICrewAgentTask) ?? matched.task
            };
            (dto as any).managerAgent = promoted;
            dto.crewAgents = dto.crewAgents.filter((_, idx) => idx !== managerIdx);
          }
        }

        // Strip task/memoryMode from any remaining sub-agents. The codegen ignores them,
        // the new sidebar won't expose them, and keeping them would reintroduce drift on
        // the next save.
        dto.crewAgents = dto.crewAgents.map((agent) => {
          const cleaned = { ...agent };
          delete (cleaned as any).task;
          delete (cleaned as any).memoryMode;
          return cleaned;
        });
      }

      const { nodes, edges } = await generateAIAgentNodesAndEdges(dto.crewAgents || []);
      const processType = loadedProcessType;
      const managerAgent = this.normalizeManagerAgent((dto as any).managerAgent ?? (dto as any).manager_agent);

      state.actionName = actionToEdit.name;
      state.nodes = this.withSelection(nodes, undefined);
      state.edges = edges;
      state.crew_inputs = dto.crew_inputs || [];
      state.crew_custom_data_types = dto.crew_custom_data_types || [];
      state.processType = processType;
      state.managerAgent = managerAgent;
      state.crewMemoryOptions = this.normalizeCrewMemoryOptions((dto as any).memoryOptions);
      state.conversationHistoryEnabled = !!(dto as any).conversationHistoryEnabled;
      state.selectedTemplateId = dto.templateId;
      state.isCreatingCustomTemplate = true;
      state.isTemplatesLoading = false;
      state.selectedAgentId = undefined;

      formValues.name = actionToEdit.name;

      // Fetch models so the canvas can show shutdown/deprecated banners
      const modelsResult = await this.getModels().catch(() => undefined);
      if (modelsResult) {
        state.agentModels = modelsResult;
      }
    } else {
      const [modelsResult, templatesResult] = await Promise.allSettled([this.getModels(), this.getTemplates()]);
      state.agentModels = modelsResult.status === "fulfilled" ? (modelsResult.value ?? []) : [];
      state.agentTemplates = templatesResult.status === "fulfilled" ? (templatesResult.value?.data ?? []) : [];
      state.isTemplatesLoading = false;
    }
    state.hasManualChanges = false;
    this.setState(state, () => {
      this.formRef.current?.setFieldsValue(formValues);
      this.objectHash = this.getObjectHash();
    });
  };

  getModels = async () => {
    try {
      const res = await DatasourceService.GetAiModels();
      return res.data;
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
      return;
    }
  };

  getTemplates = async () => {
    try {
      const res = await DatasourceService.GetAgentTemplates();
      return res;
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
      return;
    }
  };

  handleUnload = async (event: BeforeUnloadEvent) => {
    await this.clearChatHistory();
    event.preventDefault();
    event.returnValue = ""; // Required for some browsers
  };

  clearChatHistory = async () => {
    try {
      await OpenAIService.ClearChatHistory({ sessionId: this.sessionId });
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    }
  };

  normalizeProcessType = (processType: unknown): CrewProcessType => {
    if (typeof processType === "number") {
      return PROCESS_TYPE_FROM_NUMBER[processType] ?? "sequential";
    }
    return processType === "hierarchical" ? "hierarchical" : "sequential";
  };

  hasCreatedProcessTypeBefore = (processType: CrewProcessType): boolean => {
    const aiAgentActions = this.getAIAgentActions();

    return aiAgentActions.some((action) => {
      if (!action.aiAgentInfo) {
        return false;
      }

      try {
        const dto = JSON.parse(action.aiAgentInfo) as ICrewAgentDTO & {
          processType?: CrewProcessType;
          process_type?: CrewProcessType;
        };
        const resolvedProcessType = this.normalizeProcessType(dto.processType ?? dto.process_type);
        return resolvedProcessType === processType;
      } catch {
        return false;
      }
    });
  };

  normalizeManagerAgent = (managerAgent: unknown): ICrewManagerAgent | undefined => {
    if (!managerAgent) {
      return undefined;
    }

    // Legacy shape: `managerAgent` was serialized as just the manager's name (string),
    // expecting the backend to look up the matching full agent by name in crewAgents.
    // Under KOA-14774 the manager is a full top-level object. We return a stub here; the
    // caller (migrateLegacyHierarchicalDTO) promotes the matching crewAgent node into
    // this manager with role/goal/backstory/task intact.
    if (typeof managerAgent === "string") {
      const name = managerAgent.trim();
      return name ? { name } : undefined;
    }

    if (typeof managerAgent !== "object") {
      return undefined;
    }

    const rawManagerAgent = managerAgent as Record<string, unknown>;
    const normalized: ICrewManagerAgent = {};

    if (typeof rawManagerAgent.name === "string" && rawManagerAgent.name.trim()) {
      normalized.name = rawManagerAgent.name;
    }

    if (typeof rawManagerAgent.role === "string") {
      normalized.role = rawManagerAgent.role;
    }
    if (typeof rawManagerAgent.goal === "string") {
      normalized.goal = rawManagerAgent.goal;
    }
    if (typeof rawManagerAgent.backstory === "string") {
      normalized.backstory = rawManagerAgent.backstory;
    }

    if (typeof rawManagerAgent.model === "string" && rawManagerAgent.model.trim()) {
      const resolvedId = this.resolveModelId(rawManagerAgent.model.trim(), this.state.agentModels);
      normalized.model = resolvedId || rawManagerAgent.model.trim();
    } else if (typeof rawManagerAgent.model === "object" && rawManagerAgent.model) {
      // Legacy { id, name } shape — extract to plain ID string
      const rawModel = rawManagerAgent.model as Record<string, unknown>;
      const candidateId = (rawModel.id as string) || (rawModel.name as string) || "";
      if (candidateId) {
        const resolvedId = this.resolveModelId(candidateId, this.state.agentModels);
        normalized.model = resolvedId || candidateId;
      }
    }

    if (typeof rawManagerAgent.functionCallingLlm === "string" && rawManagerAgent.functionCallingLlm.trim()) {
      const resolvedId = this.resolveModelId(rawManagerAgent.functionCallingLlm.trim(), this.state.agentModels);
      normalized.functionCallingLlm = resolvedId || rawManagerAgent.functionCallingLlm.trim();
    } else if (typeof rawManagerAgent.functionCallingLlm === "object" && rawManagerAgent.functionCallingLlm) {
      const rawFc = rawManagerAgent.functionCallingLlm as Record<string, unknown>;
      const candidateId = (rawFc.id as string) || (rawFc.name as string) || "";
      if (candidateId) {
        const resolvedId = this.resolveModelId(candidateId, this.state.agentModels);
        normalized.functionCallingLlm = resolvedId || candidateId;
      }
    }

    // Memory: prefer the new `memoryMode` enum; fall back to legacy `memory` boolean for migration.
    if (typeof rawManagerAgent.memoryMode === "number") {
      normalized.memoryMode = rawManagerAgent.memoryMode as ECrewAiAgentMemoryMode;
    } else if (typeof rawManagerAgent.memory === "boolean") {
      normalized.memoryMode = rawManagerAgent.memory ? ECrewAiAgentMemoryMode.Shared : ECrewAiAgentMemoryMode.Disabled;
    }

    if (rawManagerAgent.task && typeof rawManagerAgent.task === "object") {
      const rawTask = rawManagerAgent.task as Record<string, unknown>;
      const normalizedTask: ICrewAgentTask = { description: "", expected_output: "", output_format: {} };

      if (typeof rawTask.description === "string") {
        normalizedTask.description = rawTask.description;
      }
      if (typeof rawTask.expected_output === "string") {
        normalizedTask.expected_output = rawTask.expected_output;
      }
      if (rawTask.output_format && typeof rawTask.output_format === "object") {
        normalizedTask.output_format = rawTask.output_format as Record<string, string>;
      }
      if (typeof rawTask.guardrail === "string") {
        normalizedTask.guardrail = rawTask.guardrail;
      }
      if (typeof rawTask.guardrailMaxRetryLimit === "number") {
        normalizedTask.guardrailMaxRetryLimit = rawTask.guardrailMaxRetryLimit;
      }

      normalized.task = normalizedTask;
    }

    return Object.keys(normalized).length > 0 ? normalized : undefined;
  };

  // Extracts just the `embedder` field from a persisted CrewInfoModel.MemoryOptions
  // object. We don't round-trip the full options blob (weights/thresholds) because
  // those are backend-managed today and we don't want the designer to clobber them
  // with undefined after a deserialize -> reserialize round trip.
  normalizeCrewMemoryOptions = (raw: unknown): ICrewMemoryOptions | undefined => {
    if (!raw || typeof raw !== "object") return undefined;
    const embedder = (raw as { embedder?: unknown }).embedder;
    if (!embedder || typeof embedder !== "object") return undefined;
    const e = embedder as Record<string, unknown>;
    const name = typeof e.name === "string" ? e.name : undefined;
    const id = typeof e.id === "string" ? e.id : undefined;
    const providerId = typeof e.providerId === "string" ? e.providerId : undefined;
    if (!name && !id) return undefined;
    return { embedder: { id, name, providerId } };
  };

  isGuidValue = (value?: string): boolean => {
    if (!value) {
      return false;
    }

    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  };

  resolveModelId = (modelValue: string, models: IAiAgentModel[]): string | undefined => {
    const trimmed = modelValue.trim();
    if (!trimmed) {
      return undefined;
    }

    if (this.isGuidValue(trimmed)) {
      return trimmed;
    }

    const byId = models.find((model) => model.id === trimmed);
    if (byId?.id) {
      return byId.id;
    }

    const byName = models.find((model) => model.name === trimmed);
    return byName?.id;
  };

  getObjectHash(): string {
    const {
      actionName,
      nodes,
      edges,
      crew_inputs,
      crew_custom_data_types,
      selectedTemplateId,
      processType,
      managerAgent,
      crewMemoryOptions
    } = this.state;

    return ObjectHash({
      actionName,
      nodes,
      edges,
      crew_inputs,
      crew_custom_data_types,
      selectedTemplateId,
      processType,
      managerAgent,
      crewMemoryOptions
    });
  }

  isTemplateOriginAction = (): boolean => {
    if (this.state.selectedTemplateId && this.state.selectedTemplateId !== "custom") {
      return true;
    }

    if (!this.props.actionToEdit?.aiAgentInfo) {
      return false;
    }

    try {
      const dto = JSON.parse(this.props.actionToEdit.aiAgentInfo) as ICrewAgentDTO;
      return !!dto.templateId;
    } catch {
      return false;
    }
  };

  handleProcessTypeChange = (processType: CrewProcessType) => {
    if (this.isTemplateOriginAction()) {
      return;
    }

    const nextProcessType = this.normalizeProcessType(processType);
    const nextManagerAgent = nextProcessType === "hierarchical" ? this.state.managerAgent : undefined;
    const hasChanged =
      this.state.processType !== nextProcessType || !_.isEqual(this.state.managerAgent, nextManagerAgent);

    if (!hasChanged) {
      return;
    }

    this.pushToHistory();
    this.setState((prev) => ({
      processType: nextProcessType,
      managerAgent: nextManagerAgent,
      hasManualChanges: prev.hasManualChanges || hasChanged
    }));
  };

  handleManagerAgentChange = (managerAgent?: ICrewManagerAgent) => {
    if (this.isTemplateOriginAction()) {
      return;
    }

    const normalizedManagerAgent = this.normalizeManagerAgent(managerAgent);
    const hasChanged = !_.isEqual(this.state.managerAgent, normalizedManagerAgent);

    if (!hasChanged) {
      return;
    }

    this.pushToHistory();
    this.setState((prev) => ({
      managerAgent: normalizedManagerAgent,
      hasManualChanges: prev.hasManualChanges || hasChanged
    }));
  };

  handleCrewMemoryOptionsChange = (memoryOptions?: ICrewMemoryOptions) => {
    if (this.isTemplateOriginAction()) {
      return;
    }

    const normalized = this.normalizeCrewMemoryOptions(memoryOptions);
    const hasChanged = !_.isEqual(this.state.crewMemoryOptions, normalized);
    if (!hasChanged) {
      return;
    }

    this.pushToHistory();
    this.setState((prev) => ({
      crewMemoryOptions: normalized,
      hasManualChanges: prev.hasManualChanges || hasChanged
    }));
  };

  closeDataSource() {
    if (!runParkedNavigation(this.props.nextCallback, this.props.setNextCallbackFunction)) {
      this.props.sd.cancelCreatingOrEditingDatasource();
    }
  }

  handleCloseDatasource() {
    if (this.objectHash === this.getObjectHash()) {
      this.closeDataSource();
      return;
    }

    this.props.setShowModal(true);
  }

  handleScrollToBottom = () => {
    const lastMessage =
      this.chatbotMessagesContainerRef?.current?.children[this.chatbotMessagesContainerRef.current.children.length - 1];

    lastMessage?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest"
    });
  };

  onMessageSend = async (message: string) => {
    try {
      this.setState({ isSaveDisabled: true });
      let chatbotMessages = [...this.state.chatbotMessages, { content: message, role: EOpenAIUserRole.User }];
      this.setState({ chatbotMessages }, () => {
        this.handleScrollToBottom();
      });

      const previousAgentData = {
        crewAgents: this.state.nodes.map((node) => node.data.metadata),
        crew_inputs: this.state.crew_inputs,
        crew_custom_data_types: this.state.crew_custom_data_types,
        processType: this.state.processType,
        managerAgent: this.state.managerAgent,
        memoryOptions: this.state.crewMemoryOptions
      } as unknown as ICrewAgentDTO;

      const payload: IGenerateAgentRequestDTO = {
        userMessage: message,
        previousAgent: JSON.stringify(previousAgentData),
        sessionId: this.sessionId,
        processType: this.state.processType
      };

      const chatResponse = await OpenAIService.ChatGenerateAgent(payload);

      if (chatResponse.status !== 200) return;

      const chatResponseData: IAgentChatResponseDTO = JSON.parse(
        chatResponse.data.responseMessage.content.replace("```json", "").replace("```", "")
      );

      // Ensure assistant_message is a string (it may be an array from the API)
      const assistantMessageContent = Array.isArray(chatResponseData.assistant_message)
        ? chatResponseData.assistant_message.join("\n")
        : chatResponseData.assistant_message;

      chatbotMessages = [
        ...this.state.chatbotMessages,
        { content: assistantMessageContent, role: EOpenAIUserRole.Assistant }
      ];
      this.setState({ chatbotMessages }, () => {
        this.handleScrollToBottom();
      });

      if (chatResponseData.is_agent_ready_for_creation) {
        const createAgentResponse = await OpenAIService.GenerateAgent({
          userMessage: chatResponseData.agent_prompt,
          previousAgent: JSON.stringify(previousAgentData),
          sessionId: this.sessionId,
          processType: this.state.processType
        });
        if (createAgentResponse.status !== 200) return;

        const dto: ICrewAgentDTO = JSON.parse(
          createAgentResponse.data.responseMessage.content.replace("```json", "").replace("```", "")
        );
        const processType = this.normalizeProcessType(
          (dto as any).processType ?? (dto as any).process_type ?? this.state.processType
        );
        const managerAgent = this.normalizeManagerAgent(
          (dto as any).managerAgent ?? (dto as any).manager_agent ?? this.state.managerAgent
        );
        const crewMemoryOptions =
          this.normalizeCrewMemoryOptions((dto as any).memoryOptions) ?? this.state.crewMemoryOptions;

        // Preserve model field from previous agents if backend didn't return it
        const previousAgents = this.state.nodes.map((node) => node.data.metadata);
        dto.crewAgents = dto.crewAgents.map((agent) => {
          const previousAgent = previousAgents.find((pa) => pa.name === agent.name);
          if (previousAgent?.model && !agent.model) {
            agent.model = previousAgent.model;
          }
          return agent;
        });

        const { nodes, edges } = await generateAIAgentNodesAndEdges(dto.crewAgents);

        // Strip auto-managed conversation history fields that the AI chat may have added
        const conversationHistoryEnabled = !!(dto as any).conversationHistoryEnabled;
        let crewInputs = dto.crew_inputs || [];
        if (conversationHistoryEnabled) {
          const autoManaged = ["session_id", "user_message", "conversation_history"];
          crewInputs = crewInputs.filter((i) => !autoManaged.includes(i.parameter_name));
        }

        this.setState(
          {
            // chatbotMessages,
            crew_inputs: crewInputs,
            crew_custom_data_types: dto.crew_custom_data_types,
            processType,
            managerAgent,
            crewMemoryOptions,
            conversationHistoryEnabled,
            nodes,
            edges,
            hasManualChanges: false
          },
          () => {
            this.handleScrollToBottom();
          }
        );
      }
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
      // Ensure we reset the fixing state even on error
      if (this.state.isFixingAgents) {
        this.setState({ isFixingAgents: false });
      }
    } finally {
      try {
        if (this.state.isFixingAgents) {
          this.setState({
            showFixesAppliedModal: true,
            isFixingAgents: false,
            hasManualChanges: false
          });
        }
        this.setState({ isSaveDisabled: false }, () => {
          // Focus the input field after response has been loaded
          try {
            this.chatbotRef.current?.focusInput();
          } catch (e) {
            console.error("Error focusing chatbot:", e);
          }
        });
      } catch (e) {
        console.error("Error in finally block:", e);
      }
    }
  };

  // This helper ignores synthetic entries, refreshes once before giving up, and
  // recovers from a duplicate-name response by re-fetching and locating the real row.
  private ensureAiAgentDatasourceId = async (): Promise<string> => {
    const findReal = (): string | undefined =>
      this.props.sd.datasources.find((ds) => ds.datasourceType === EDatasourceType.AIAgent && !!ds.id)?.id;

    let id = this.props.actionDatasource?.id || findReal();
    if (id) return id;

    // Local state may still hold the synthetic placeholder — refresh before creating.
    await this.props.sd.refreshDatabases();
    id = findReal();
    if (id) return id;

    try {
      await DatasourceService.SaveDatasource({
        name: "AIAgents",
        datasourceType: EDatasourceType.AIAgent
      } as IDatasourceDto);
    } catch (err) {
      // If the backend rejects with a duplicate-name error, fall through to the
      // refresh-and-lookup below; any other error is fatal.
      const message = String((err as Error)?.message ?? err ?? "").toLowerCase();
      if (!message.includes("already")) throw err;
    }

    await this.props.sd.refreshDatabases();
    id = findReal();
    if (!id) throw new Error("AI Agent datasource is not implemented please contact to the customer service");
    return id;
  };

  saveAction = async (status: EAiActionStatus | unknown = EAiActionStatus.Published) => {
    // The commit is live again as soon as the ✓ replaces the spinner, so a second press would
    // re-fire the save behind the closing editor.
    if (!this.saveStatus.canStart) return;
    try {
      this.saveStatus.start();
      this.setState({ isSaveDisabled: true });
      const normalizedStatus =
        typeof status === "number" && (status === EAiActionStatus.Draft || status === EAiActionStatus.Published)
          ? status
          : EAiActionStatus.Published;
      const aiAgentDatasourceId = await this.ensureAiAgentDatasourceId();

      const { nodes, actionName, selectedTemplateId, processType, managerAgent } = _.cloneDeep(this.state);
      // if (nodes.length === 0) throw new Error("There are no agent defined on diagram.");

      nodes.forEach((node) => {
        const hasMcpToolWithoutSettings = node.data.metadata.tools?.find(
          (tool) => tool.mcpConfigName && !tool.settingsId
        );

        if (hasMcpToolWithoutSettings) throw new Error("Please configure all MCP tools before save the AI Agent.");
      });

      let availableModels = this.state.agentModels || [];
      if (!availableModels.length) {
        try {
          const modelsResponse = await DatasourceService.GetAiModels();
          availableModels = modelsResponse?.data || [];
        } catch {
          availableModels = [];
        }
      }

      const invalidAgentModels: string[] = [];

      // Normalize model field to always be an object for backend compatibility
      const normalizedAgents = nodes.map((node) => {
        const agent = { ...node.data.metadata };
        if (agent.model) {
          if (typeof agent.model === "string") {
            const resolvedModelId = this.resolveModelId(agent.model, availableModels);
            if (resolvedModelId) {
              agent.model = resolvedModelId;
            } else {
              invalidAgentModels.push(`${agent.name || "Unnamed Agent"}: ${agent.model}`);
            }
          } else if (typeof agent.model === "object") {
            // Legacy { id, name } shape — extract and resolve to plain ID string
            const rawModelId = typeof (agent.model as any).id === "string" ? (agent.model as any).id : undefined;
            const rawModelName = typeof (agent.model as any).name === "string" ? (agent.model as any).name : undefined;
            const candidateModel = rawModelId || rawModelName;

            if (candidateModel) {
              const resolvedModelId = this.resolveModelId(candidateModel, availableModels);
              if (resolvedModelId) {
                agent.model = resolvedModelId;
              } else {
                invalidAgentModels.push(`${agent.name || "Unnamed Agent"}: ${candidateModel}`);
              }
            }
          }
        }
        if (agent.functionCallingLlm) {
          if (typeof agent.functionCallingLlm === "string") {
            const resolvedId = this.resolveModelId(agent.functionCallingLlm, availableModels);
            if (resolvedId) {
              agent.functionCallingLlm = resolvedId;
            } else {
              invalidAgentModels.push(`${agent.name || "Unnamed Agent"}: ${agent.functionCallingLlm}`);
            }
          } else if (typeof agent.functionCallingLlm === "object") {
            const raw = agent.functionCallingLlm as any;
            const rawId = typeof raw.id === "string" ? raw.id : undefined;
            const rawName = typeof raw.name === "string" ? raw.name : undefined;
            const candidate = rawId || rawName;
            if (candidate) {
              const resolvedId = this.resolveModelId(candidate, availableModels);
              if (resolvedId) {
                agent.functionCallingLlm = resolvedId;
              } else {
                invalidAgentModels.push(`${agent.name || "Unnamed Agent"}: ${candidate}`);
              }
            }
          }
        }
        return agent;
      });

      if (invalidAgentModels.length > 0) {
        throw new Error(
          `Invalid agent model selection: ${invalidAgentModels.join(", ")}. Please reselect model(s) from dropdown.`
        );
      }

      let effectiveProcessType: CrewProcessType = processType;
      let effectiveManagerAgent: ICrewManagerAgent | undefined = managerAgent;

      // Defensive lock: template-origin actions must preserve process/manager values from original payload.
      if (this.isTemplateOriginAction() && this.props.actionToEdit?.aiAgentInfo) {
        try {
          const originalDto = JSON.parse(this.props.actionToEdit.aiAgentInfo) as ICrewAgentDTO;
          const originalProcessType = this.normalizeProcessType(
            (originalDto as any).processType ?? (originalDto as any).process_type
          );
          const originalManagerAgent = this.normalizeManagerAgent(
            (originalDto as any).managerAgent ?? (originalDto as any).manager_agent
          );

          effectiveProcessType = originalProcessType;
          effectiveManagerAgent = originalManagerAgent;
        } catch {
          // Keep current state values if payload cannot be parsed.
        }
      }

      if (effectiveProcessType === "hierarchical" && !effectiveManagerAgent?.name?.trim()) {
        throw new Error("Manager agent is required when process type is hierarchical.");
      }

      // Normalize manager agent model to plain ID string
      if (effectiveManagerAgent?.model) {
        const rawModel = effectiveManagerAgent.model;
        const candidateModel = typeof rawModel === "string" ? rawModel : (rawModel as any).id || (rawModel as any).name;
        if (candidateModel) {
          const resolvedId = this.resolveModelId(String(candidateModel), availableModels);
          if (resolvedId) {
            effectiveManagerAgent = { ...effectiveManagerAgent, model: resolvedId };
          }
        }
      }
      if (effectiveManagerAgent?.functionCallingLlm) {
        const resolvedId = this.resolveModelId(effectiveManagerAgent.functionCallingLlm, availableModels);
        if (resolvedId) {
          effectiveManagerAgent = { ...effectiveManagerAgent, functionCallingLlm: resolvedId };
        }
      }
      // KOA-14774 hierarchical model: sub-agents are pure capability profiles. Strip
      // any task/memoryMode data from sub-agents defensively even if the UI still
      // allows editing them on legacy records. Also filter the manager out of
      // crewAgents if a legacy record has it there (the manager is serialized as
      // a full top-level object, not by name reference).
      let crewAgentsForPayload = normalizedAgents;
      if (effectiveProcessType === "hierarchical") {
        const managerName = effectiveManagerAgent?.name?.trim();
        crewAgentsForPayload = normalizedAgents
          .filter((a) => !managerName || a.name?.trim() !== managerName)
          .map((a) => {
            const cleaned = { ...a };
            delete (cleaned as any).task;
            delete (cleaned as any).memoryMode;
            return cleaned;
          });
      }

      // Auto-enable crew memory iff any agent (or manager) uses Shared mode.
      // Backend codegen references `crew_memory` for Shared agents and only emits it when memoryEnabled === true.
      const hasSharedAgent = crewAgentsForPayload.some((a) => a.memoryMode === ECrewAiAgentMemoryMode.Shared);
      const hasSharedManager = effectiveManagerAgent?.memoryMode === ECrewAiAgentMemoryMode.Shared;
      const memoryEnabled = hasSharedAgent || hasSharedManager;

      // Backend expects model as { id: "..." } object (CrewAiModelConfig), not a plain string.
      // Convert plain ID strings to the object shape for serialization.
      const serializeModel = (model?: string) => (model ? { id: model } : undefined);

      const serializedAgents = crewAgentsForPayload.map((a) => ({
        ...a,
        model: serializeModel(typeof a.model === "string" ? a.model : undefined),
        functionCallingLlm: serializeModel(typeof a.functionCallingLlm === "string" ? a.functionCallingLlm : undefined)
      }));

      // When conversation history is enabled, strip any auto-managed fields the AI chat
      // may have added (including localized variants), then append the canonical ones ourselves.
      const CONVERSATION_HISTORY_INPUTS = ["session_id", "user_message", "conversation_history"];
      let filteredInputs = this.state.crew_inputs;
      if (this.state.conversationHistoryEnabled) {
        filteredInputs = this.state.crew_inputs.filter((i) => !CONVERSATION_HISTORY_INPUTS.includes(i.parameter_name));
        filteredInputs.push(
          { parameter_name: "session_id", parameter_format: "str" },
          { parameter_name: "user_message", parameter_format: "str" }
        );
      }

      const agentInfo: any = {
        crewAgents: serializedAgents,
        crew_inputs: filteredInputs,
        crew_custom_data_types: this.state.crew_custom_data_types,
        processType: PROCESS_TYPE_TO_NUMBER[effectiveProcessType],
        conversationHistoryEnabled: this.state.conversationHistoryEnabled
      };

      if (effectiveProcessType === "hierarchical" && effectiveManagerAgent?.name) {
        agentInfo.managerAgent = {
          ...effectiveManagerAgent,
          model: serializeModel(
            typeof effectiveManagerAgent.model === "string" ? effectiveManagerAgent.model : undefined
          ),
          functionCallingLlm: serializeModel(effectiveManagerAgent.functionCallingLlm)
        };
      }

      // Only include crew-level memoryOptions when shared memory is actually in play --
      // otherwise the backend would get a dangling embedder config for a disabled feature.
      if (memoryEnabled && this.state.crewMemoryOptions?.embedder) {
        // Backend counterpart: CrewInfoModel.MemoryOptions with CrewAiModelConfig { id, name, providerId }.
        const { id, name, providerId } = this.state.crewMemoryOptions.embedder;
        if (name) {
          const embedder: Record<string, string> = { name };
          if (id) embedder.id = id;
          if (providerId) embedder.providerId = providerId;
          agentInfo.memoryOptions = { embedder };
        }
      }

      // Only include templateId if it's not "custom" (which is used for blank templates)
      if (selectedTemplateId && selectedTemplateId !== "custom") {
        agentInfo.templateId = selectedTemplateId;
      }

      const action = {
        id: this.props.actionToEdit?.id || undefined,
        name: actionName,
        kDatasource_Id: aiAgentDatasourceId,
        actionType: EDatasourceType.AIAgent,
        aiActionStatus: normalizedStatus,
        aiAgentInfo: JSON.stringify(agentInfo),
        parameters: []
      } as unknown as IActionDefinitionDto;
      const response = await DatasourceService.SaveAction(action);
      if (response.status !== 200) {
        // A resolved response that is not 200: the `finally` reset used to rescue this branch.
        this.saveStatus.fail();
        return;
      }
      this.props.sd.refreshDatabases();
      this.props.sd.refreshActions();
      // The ✓ goes up first and the editor leaves after it — see `SaveStatus`.
      // A close confirmation this save answered ("Update & close") steps aside at once, so
      // the ✓ on the button is what is seen before the editor leaves.
      this.props.setShowModal(false);
      this.saveStatus.succeed((): void => {
        // The list behind the editor lights the row up; the button has already said "Saved".
        requestDatasourceReveal({ name: actionName, parentId: aiAgentDatasourceId });
        if (this.props.actionDatasource) this.closeDataSource();
        else {
          const ds = response.data.find((ds) => ds.name === actionName);
          this.props.sd.setActiveEditingDatasource(ds);
        }
      });
    } catch (e) {
      this.saveStatus.fail();
      KMainFunctions.exceptionHandler(e);
    } finally {
      this.setState({ isSaveDisabled: false });
    }
  };

  handleSaveClick = (status: EAiActionStatus = EAiActionStatus.Published) => {
    if (this.state.processType === "hierarchical" && !this.state.managerAgent?.name?.trim()) {
      KMainFunctions.displayWarningNotification("Manager agent is required when process type is hierarchical.");
      return;
    }

    if (this.state.autoFixEnabled) {
      // Auto-fix toggle is the explicit user intent: ALWAYS run fix when ON,
      // regardless of hasManualChanges (which gets reset by chat generation,
      // blank-canvas creation, and post-fix flows).
      this.setState({ isFixingAgents: true });
      this.handleCheckAgents();
    } else {
      this.saveAction(status);
    }
  };

  handlePublishClick = () => {
    this.handleSaveClick(EAiActionStatus.Published);
  };

  handleSaveDraftClick = () => {
    this.handleSaveClick(EAiActionStatus.Draft);
  };

  handleSubmitNameChange = () => {
    const errors = this.formRef.current?.getFieldError("name");
    if (errors && errors.length > 0) {
      return;
    }
    this.setState({
      isNameOnEdit: false,
      actionName: this.formRef.current?.getFieldValue("name")
    });
  };

  handleAbortNameChange = () => {
    if (!this.state.actionName) {
      KMainFunctions.displayWarningNotification("Please enter a valid AI Agent name");
      return;
    }

    this.formRef.current?.setFieldsValue({
      ...this.formRef.current.getFieldsValue(),
      name: this.state.actionName
    });
    this.setState({ isNameOnEdit: false });
  };

  handleNameInputOnEnter = (e: ReactKeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter") {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    this.handleSubmitNameChange();
  };

  withSelection = (nodes: IElkNode[], selectedId?: string): IElkNode[] =>
    nodes.map((node) => ({
      ...node,
      selected: node.id === selectedId,
      data: {
        ...node.data,
        isAnySelected: !!selectedId
      }
    }));

  selectNode = (nodeId: string) => {
    this.setState((prev) => ({
      selectedAgentId: nodeId,
      // Selecting any node implies we're no longer focused on the manager.
      isManagerSelected: false,
      rightPanelTab: "params",
      mcpModalIndexes: undefined,
      nodes: this.withSelection(prev.nodes, nodeId)
    }));
  };

  clearSelectedNode = () => {
    this.setState((prev) => ({
      selectedAgentId: undefined,
      nodes: this.withSelection(prev.nodes, undefined)
    }));
  };

  updateNodeTool = (nodeId: string, tools: ICrewAgentTool[]) => {
    this.pushToHistory();
    this.setState((prev) => {
      const nodes = _.cloneDeep(prev.nodes);
      const node = nodes.find((item) => item.id === nodeId);
      if (!node) {
        return null;
      }
      node.data.metadata.tools = tools;
      return {
        nodes: this.withSelection(nodes, prev.selectedAgentId),
        hasManualChanges: true
      };
    });
  };

  updateNodeName = (nodeId: string, name: string) => {
    this.pushToHistory();
    this.setState((prev) => {
      const nodes = _.cloneDeep(prev.nodes);
      const node = nodes.find((item) => item.id === nodeId);
      if (!node) {
        return null;
      }
      node.data.metadata.name = name;
      return {
        nodes: this.withSelection(nodes, prev.selectedAgentId),
        hasManualChanges: true
      };
    });
  };

  updateNodeDescription = (nodeId: string, description: string) => {
    this.setState((prev) => {
      const nodes = _.cloneDeep(prev.nodes);
      const node = nodes.find((item) => item.id === nodeId);
      if (!node || !node.data.metadata.task) {
        return null;
      }
      node.data.metadata.task.description = description;
      return {
        nodes: this.withSelection(nodes, prev.selectedAgentId),
        hasManualChanges: true
      };
    });
  };

  updateModel = (nodeId: string, model: any) => {
    this.pushToHistory();
    this.setState((prev) => {
      const nodes = _.cloneDeep(prev.nodes);
      const node = nodes.find((item) => item.id === nodeId);
      if (!node) {
        return null;
      }

      node.data.metadata.model = model;

      return {
        nodes: this.withSelection(nodes, prev.selectedAgentId),
        hasManualChanges: true
      };
    });
  };

  updateMemory = (nodeId: string, mode: ECrewAiAgentMemoryMode) => {
    this.pushToHistory();
    this.setState((prev) => {
      const nodes = _.cloneDeep(prev.nodes);
      const node = nodes.find((item) => item.id === nodeId);
      if (!node) {
        return null;
      }

      node.data.metadata.memoryMode = mode;

      return {
        nodes: this.withSelection(nodes, prev.selectedAgentId),
        hasManualChanges: true
      };
    });
  };

  handleOpenMcpModal = (nodeId: string, toolIndex: number) => {
    this.setState((prev) => ({
      mcpModalIndexes: { nodeId, toolIndex },
      selectedAgentId: nodeId,
      // Clicking a sub-agent's tool implies we're no longer focused on the manager.
      // Without this, the sidebar stays in manager mode and hides the tool config.
      isManagerSelected: false,
      rightPanelTab: "params",
      ...(prev.selectedAgentId !== nodeId ? { walkthroughPreferredAccordionKey: "tools_" } : {})
    }));
  };

  handleSidebarMcpSettingsSave = (toolIndex: number, settingsId: string | undefined) => {
    const nodes = _.cloneDeep(this.state.nodes);
    const toolNode = nodes.find((node) => node.id === this.state.mcpModalIndexes?.nodeId);
    const tool = toolNode?.data.metadata.tools?.[toolIndex];
    if (!toolNode || !tool) return;
    tool.settingsId = settingsId;
    this.setState((prev) => ({
      nodes: this.withSelection(nodes, prev.selectedAgentId),
      hasManualChanges: true
    }));
  };

  removeNode = async (nodeId) => {
    this.pushToHistory();
    const { nodes, edges } = await generateAIAgentNodesAndEdges(
      this.state.nodes.filter((node) => node.id !== nodeId).map((node) => node.data.metadata)
    );

    this.setState((prev) => {
      let selectedAgentId = prev.selectedAgentId;
      if (selectedAgentId === nodeId || !nodes.some((node) => node.id === selectedAgentId)) {
        selectedAgentId = undefined;
      }
      return {
        nodes: this.withSelection(nodes, selectedAgentId),
        edges,
        selectedAgentId,
        hasManualChanges: true
      };
    });
  };

  copyNode = async (nodeId: string) => {
    this.pushToHistory();
    const nodeIndex = this.state.nodes.findIndex((n) => n.id === nodeId);
    if (nodeIndex === -1) return;
    const originalMeta = _.cloneDeep(this.state.nodes[nodeIndex].data.metadata);
    const copiedAgent = { ...originalMeta, name: `${originalMeta.name} Copy` };
    const agentMetadatas = [
      ...this.state.nodes.slice(0, nodeIndex + 1).map((n) => n.data.metadata),
      copiedAgent,
      ...this.state.nodes.slice(nodeIndex + 1).map((n) => n.data.metadata)
    ];
    const { nodes, edges } = await generateAIAgentNodesAndEdges(agentMetadatas);
    this.setState({
      nodes: this.withSelection(nodes, undefined),
      edges,
      hasManualChanges: true
    });
  };

  fitCanvasToView = () => {
    const runFitView = () => {
      this.reactFlowInstance?.fitView?.();
    };

    requestAnimationFrame(() => {
      runFitView();
      // In hierarchical mode, custom node sizing/position can settle a tick later.
      // Re-running fitView keeps behavior identical to the toolbar action but reliable.
      setTimeout(runFitView, 80);
      setTimeout(runFitView, 220);
    });
  };

  handleAddAgent = async (shouldFitView: boolean = false) => {
    this.pushToHistory();
    const newAgent: ICrewAgent = {
      name: `Agent ${this.state.nodes.length + 1}`,
      role: "",
      goal: "",
      backstory: "",
      task: {
        description: "Define what this agent should do",
        expected_output: "Define the expected output format",
        output_format: {}
      },
      tools: []
    };

    const agents = [...this.state.nodes.map((node) => node.data.metadata), newAgent];
    const { nodes, edges } = await generateAIAgentNodesAndEdges(agents);

    this.setState(
      (prev) => {
        const selectedAgentId =
          prev.selectedAgentId && nodes.some((node) => node.id === prev.selectedAgentId)
            ? prev.selectedAgentId
            : undefined;
        return {
          nodes: this.withSelection(nodes, selectedAgentId),
          edges,
          selectedAgentId,
          hasManualChanges: true
        };
      },
      () => {
        if (shouldFitView) {
          this.fitCanvasToView();
        }
      }
    );
  };

  handlePaletteAgentDragStart = (event: React.DragEvent<HTMLButtonElement>) => {
    if (this.state.viewMode === "preview" || this.state.showProcessTypeWalkthrough) {
      event.preventDefault();
      return;
    }

    event.dataTransfer.setData(AI_AGENT_PALETTE_DRAG_TYPE, "agent");
    event.dataTransfer.effectAllowed = "move";
  };

  handleCanvasDragOver = (event: React.DragEvent) => {
    if (this.state.viewMode === "preview" || this.state.showProcessTypeWalkthrough) {
      return;
    }

    if (!event.dataTransfer.types.includes(AI_AGENT_PALETTE_DRAG_TYPE)) {
      return;
    }

    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };

  handleCanvasDrop = async (event: React.DragEvent) => {
    if (this.state.viewMode === "preview" || this.state.showProcessTypeWalkthrough) {
      return;
    }

    const droppedItemType = event.dataTransfer.getData(AI_AGENT_PALETTE_DRAG_TYPE);
    if (droppedItemType !== "agent") {
      return;
    }

    event.preventDefault();
    await this.handleAddAgent(true);
  };

  toggleCanvasPanMode = () => {
    this.setState((prev) => ({ isCanvasPanEnabled: !prev.isCanvasPanEnabled }));
  };

  renderAIAgentFloatingPalette = () => {
    const isEditingAllowed = this.state.viewMode !== "preview";

    const agentModels = this.state.agentModels as any[];
    const resolveModelStatus = (modelRef: any): EAiModelStatus | null => {
      if (!modelRef) return null;
      const modelKey = typeof modelRef === "object" ? modelRef.id || modelRef.name : modelRef;
      const found = agentModels.find((m: any) => m.id === modelKey || m.name === modelKey);
      if (!found) return null;
      return (found.status as EAiModelStatus) ?? EAiModelStatus.Active;
    };

    const shutdownItems: string[] = [];
    const deprecatedItems: string[] = [];
    this.state.nodes.forEach((node) => {
      const agent = node.data.metadata;
      const status = resolveModelStatus(agent.model);
      if (status === EAiModelStatus.Shutdown) {
        shutdownItems.push(agent.name || "Agent");
      } else if (status === EAiModelStatus.Deprecated) {
        deprecatedItems.push(agent.name || "Agent");
      }
    });
    if (this.state.processType === "hierarchical" && this.state.managerAgent?.model) {
      const managerStatus = resolveModelStatus(this.state.managerAgent.model);
      if (managerStatus === EAiModelStatus.Shutdown) {
        shutdownItems.push("Manager");
      } else if (managerStatus === EAiModelStatus.Deprecated) {
        deprecatedItems.push("Manager");
      }
    }
    const hasBanners = shutdownItems.length > 0 || deprecatedItems.length > 0;
    const showManagerInfo = !hasBanners && this.state.processType === "hierarchical" && this.state.showManagerFlowMsg;
    const showSequentialInfo =
      !hasBanners && this.state.processType === "sequential" && this.state.showSequentialFlowMsg;

    return (
      <div className="kuika-ai-agent__floating-palette-wrapper">
        <div className="kuika-ai-agent__category-icons">
          <KuikaTooltip content="Click and drag to drop a new Agent" position="right">
            <button
              type="button"
              className="kuika-ai-agent__category-icon"
              draggable={isEditingAllowed && !this.state.showProcessTypeWalkthrough}
              onDragStart={this.handlePaletteAgentDragStart}
              disabled={!isEditingAllowed || this.state.showProcessTypeWalkthrough}
            >
              <KuikaSvg type="datasource-icons" name="ai-agent" width={20} height={20} color="var(--blue-6)" />
            </button>
          </KuikaTooltip>

          {/* Marketplace coming soon... */}
          {/* <KuikaTooltip content="Marketplace" position="right">
            <button
              type="button"
              className="kuika-ai-agent__category-icon"
              onClick={() => KMainFunctions.displayWarningNotification("Marketplace coming soon")}
            >
              <KuikaSvg type="common" name="apps" width={20} height={20} color="var(--purple-6)" />
            </button>
          </KuikaTooltip> */}

          <KuikaTooltip content={this.state.isCanvasPanEnabled ? "Disable Pan" : "Enable Pan"} position="right">
            <button
              type="button"
              className={classNames("kuika-ai-agent__category-icon", {
                "kuika-ai-agent__category-icon--active": this.state.isCanvasPanEnabled
              })}
              onClick={this.toggleCanvasPanMode}
              disabled={this.state.showProcessTypeWalkthrough}
            >
              <KuikaSvg
                type="common"
                // name={this.state.isCanvasPanEnabled ? "hand-finger" : "hand-finger-off"}
                name={"hand-finger"}
                width={20}
                height={20}
                color={this.state.isCanvasPanEnabled ? "var(--blue-6)" : "var(--dark-6)"}
              />
            </button>
          </KuikaTooltip>
        </div>

        <div className="kuika-ai-agent__floating-palette-side-panel">
          {showManagerInfo && (
            <div className="kuika-ai-agent__manager-flow-msg">
              <div className="kuika-ai-agent__manager-flow-msg-header">
                <div className="kuika-ai-agent__manager-flow-msg-title">
                  <BulbOutlined style={{ color: "#7b5d22", fontSize: "16px" }} />
                  <span>How Manager flow works</span>
                </div>
                <CloseOutlined
                  className="kuika-ai-agent__manager-flow-msg-close"
                  onClick={() => {
                    localStorage.setItem(`kuika-ai-agent-manager-msg-dismissed-${this.sessionId}`, "1");
                    this.setState({ showManagerFlowMsg: false });
                  }}
                />
              </div>
              <div className="kuika-ai-agent__manager-flow-msg-content">
                The <strong>Manager</strong> coordinates all agents and distributes tasks automatically.Write the full
                workflow in <strong>Manager Instructions</strong>. Reference sub-agents with <strong>@AgentName</strong>
                .
              </div>
              <a
                href="https://academy.kuika.com/en/content/ai-agent#toc-ai-agent-process-types-8"
                className="kuika-ai-agent__manager-flow-msg-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More
              </a>
            </div>
          )}

          {showSequentialInfo && (
            <div className="kuika-ai-agent__manager-flow-msg">
              <div className="kuika-ai-agent__manager-flow-msg-header">
                <div className="kuika-ai-agent__manager-flow-msg-title">
                  <BulbOutlined style={{ color: "#7b5d22", fontSize: "16px" }} />
                  <span>How Sequential flow works</span>
                </div>
                <CloseOutlined
                  className="kuika-ai-agent__manager-flow-msg-close"
                  onClick={() => {
                    localStorage.setItem(`kuika-ai-agent-sequential-msg-dismissed-${this.sessionId}`, "1");
                    this.setState({ showSequentialFlowMsg: false });
                  }}
                />
              </div>
              <div className="kuika-ai-agent__manager-flow-msg-content">
                <strong>Agents</strong> execute tasks one by one in the exact order they are connected. Each agent
                passes its output to the next agent in the sequence.
              </div>
              <a
                href="https://academy.kuika.com/en/content/ai-agent#toc-ai-agent-process-types-8"
                className="kuika-ai-agent__manager-flow-msg-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More
              </a>
            </div>
          )}

          <AiModelDeprecationBanners
            shutdownItems={shutdownItems}
            deprecatedItems={deprecatedItems}
            className="kuika-notice-banner-stack--canvas"
            variant="editor"
          />
        </div>
      </div>
    );
  };

  handleAddAgentAfter = async (afterNodeId: string) => {
    this.pushToHistory();
    const currentAgents = this.state.nodes.map((node) => node.data.metadata);
    const nodeIndex = this.state.nodes.findIndex((node) => node.id === afterNodeId);

    const newAgent: ICrewAgent = {
      name: `Agent ${this.state.nodes.length + 1}`,
      role: "",
      goal: "",
      backstory: "",
      task: {
        description: "Define what this agent should do",
        expected_output: "Define the expected output format",
        output_format: {}
      },
      tools: []
    };

    // Insert the new agent after the specified node
    const agents = [...currentAgents.slice(0, nodeIndex + 1), newAgent, ...currentAgents.slice(nodeIndex + 1)];

    const { nodes, edges } = await generateAIAgentNodesAndEdges(agents);
    this.setState((prev) => {
      const selectedAgentId =
        prev.selectedAgentId && nodes.some((node) => node.id === prev.selectedAgentId)
          ? prev.selectedAgentId
          : undefined;
      return {
        nodes: this.withSelection(nodes, selectedAgentId),
        edges,
        selectedAgentId,
        hasManualChanges: true
      };
    });
  };

  handleOpenResponseModal = (selectedAgentId: string) => {
    this.setState({ showResponseModal: true, selectedAgentId, isManagerSelected: false });
  };

  handleCloseResponseModal = () => {
    this.setState({ showResponseModal: false, selectedAgentId: undefined });
  };

  handleOpenManagerResponseModal = () => {
    this.setState({ showManagerResponseModal: true });
  };

  handleCloseManagerResponseModal = () => {
    this.setState({ showManagerResponseModal: false });
  };

  handleOpenInputsModal = () => {
    this.setState({ showInputsModal: true });
  };

  handleCloseInputsModal = () => {
    this.setState({ showInputsModal: false });
  };

  handleOpenCustomTypesModal = () => {
    this.setState({ showCustomTypesModal: true });
  };

  handleCloseCustomTypesModal = () => {
    this.setState({ showCustomTypesModal: false });
  };

  handleOpenTestModal = () => {
    this.setState({ showTestModal: true });
  };

  handleCloseTestModal = () => {
    this.setState({ showTestModal: false });
  };

  openDeleteActionModal = (actionDefinition: IActionDefinitionDto) => {
    this.setState({
      actionToDelete: actionDefinition,
      isDeleteActionModalVisible: true,
      recentsMenuId: null
    });
  };

  deleteAIAgentAction = async () => {
    const { actionToDelete } = this.state;
    if (!actionToDelete) return;

    try {
      this.setState({ isDeleteActionModalVisible: false });
      await DatasourceService.DeleteAction(actionToDelete);
      await this.props.sd.loadActionDefinitions();
      this.props.sd.refreshActions();

      if (this.props.actionToEdit?.id === actionToDelete.id) {
        this.closeDataSource();
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ actionToDelete: undefined });
    }
  };

  // Applies the response schema only. The dialog closes itself once its Update ✓ has been seen, so
  // closing here would take the ✓ with it (and clear `selectedAgentId` under it).
  handleUpdateAIAgent = (agent: ICrewAgent, agentDefinitions?: ICrewCustomDataType[]) => {
    const { selectedAgentId } = this.state;
    if (!selectedAgentId) {
      this.setState({ crew_custom_data_types: agentDefinitions });
      return;
    }

    const nodes = _.cloneDeep(this.state.nodes);
    const node = nodes.find((item) => item.id === selectedAgentId);
    if (!node) {
      this.setState({ crew_custom_data_types: agentDefinitions });
      return;
    }

    const hasChanged =
      !_.isEqual(node.data.metadata, agent) || !_.isEqual(this.state.crew_custom_data_types, agentDefinitions);
    node.data.metadata = agent;

    this.setState((prev) => ({
      nodes: this.withSelection(nodes, selectedAgentId),
      crew_custom_data_types: agentDefinitions,
      hasManualChanges: prev.hasManualChanges || hasChanged
    }));
  };

  handleUpdateAIInputs = (inputs: ICrewInput[]) => {
    const hasChanged = !_.isEqual(this.state.crew_inputs, inputs);
    if (hasChanged) {
      this.pushToHistory();
    }
    this.setState({
      crew_inputs: inputs,
      hasManualChanges: this.state.hasManualChanges || hasChanged
    });
  };

  // History management for undo/redo
  createHistorySnapshot = (): IAgentHistorySnapshot => {
    return {
      nodes: _.cloneDeep(this.state.nodes),
      edges: _.cloneDeep(this.state.edges),
      crew_inputs: _.cloneDeep(this.state.crew_inputs),
      crew_custom_data_types: _.cloneDeep(this.state.crew_custom_data_types),
      processType: this.state.processType,
      managerAgent: _.cloneDeep(this.state.managerAgent),
      crewMemoryOptions: _.cloneDeep(this.state.crewMemoryOptions),
      conversationHistoryEnabled: this.state.conversationHistoryEnabled
    };
  };

  pushToHistory = () => {
    const snapshot = this.createHistorySnapshot();
    this.setState((prev) => {
      const newUndoStack = [...prev.undoStack, snapshot];
      // Limit history to 50 entries
      if (newUndoStack.length > 50) {
        newUndoStack.shift();
      }
      return {
        undoStack: newUndoStack,
        // Any new change wipes the redo stack
        redoStack: []
      };
    });
  };

  handleUndo = () => {
    const { undoStack, selectedAgentId } = this.state;
    if (undoStack.length === 0) return;

    const snapshot = undoStack[undoStack.length - 1];
    const currentSnapshot = this.createHistorySnapshot();

    // Check if selected agent still exists in the restored state
    const agentStillExists = selectedAgentId ? snapshot.nodes.some((node) => node.id === selectedAgentId) : false;
    const nodeCountChanged = snapshot.nodes.length !== this.state.nodes.length;

    this.setState(
      (prev) => ({
        nodes: snapshot.nodes,
        edges: snapshot.edges,
        crew_inputs: snapshot.crew_inputs,
        crew_custom_data_types: snapshot.crew_custom_data_types,
        processType: snapshot.processType,
        managerAgent: snapshot.managerAgent,
        crewMemoryOptions: snapshot.crewMemoryOptions,
        conversationHistoryEnabled: snapshot.conversationHistoryEnabled,
        undoStack: prev.undoStack.slice(0, -1),
        redoStack: [...prev.redoStack, currentSnapshot],
        // Only clear selection if the agent no longer exists
        selectedAgentId: agentStillExists ? selectedAgentId : undefined
      }),
      () => {
        if (nodeCountChanged) {
          this.fitCanvasToView();
        }
      }
    );
  };

  handleRedo = () => {
    const { redoStack, selectedAgentId } = this.state;
    if (redoStack.length === 0) return;

    const snapshot = redoStack[redoStack.length - 1];
    const currentSnapshot = this.createHistorySnapshot();

    // Check if selected agent still exists in the restored state
    const agentStillExists = selectedAgentId ? snapshot.nodes.some((node) => node.id === selectedAgentId) : false;
    const nodeCountChanged = snapshot.nodes.length !== this.state.nodes.length;

    this.setState(
      (prev) => ({
        nodes: snapshot.nodes,
        edges: snapshot.edges,
        crew_inputs: snapshot.crew_inputs,
        crew_custom_data_types: snapshot.crew_custom_data_types,
        processType: snapshot.processType,
        managerAgent: snapshot.managerAgent,
        crewMemoryOptions: snapshot.crewMemoryOptions,
        conversationHistoryEnabled: snapshot.conversationHistoryEnabled,
        undoStack: [...prev.undoStack, currentSnapshot],
        redoStack: prev.redoStack.slice(0, -1),
        // Only clear selection if the agent no longer exists
        selectedAgentId: agentStillExists ? selectedAgentId : undefined
      }),
      () => {
        if (nodeCountChanged) {
          this.fitCanvasToView();
        }
      }
    );
  };

  canUndo = (): boolean => {
    return this.state.undoStack.length > 0;
  };

  canRedo = (): boolean => {
    return this.state.redoStack.length > 0;
  };

  isEditableShortcutTarget = (target: EventTarget | null): boolean => {
    if (!(target instanceof Element)) {
      return false;
    }

    if (target instanceof HTMLElement && target.isContentEditable) {
      return true;
    }

    return !!target.closest(
      "input, textarea, select, [contenteditable='true'], [contenteditable=''], [role='textbox'], .monaco-editor textarea"
    );
  };

  handleWorkflowUndoRedoShortcut = (event: KeyboardEvent) => {
    if (!(event.ctrlKey || event.metaKey) || event.altKey) {
      return;
    }

    if (event.key.toLowerCase() !== "z") {
      return;
    }

    if (
      this.shouldShowTemplateSelection() ||
      this.state.viewMode !== "edit" ||
      this.isEditableShortcutTarget(event.target)
    ) {
      return;
    }

    if (event.shiftKey) {
      if (!this.canRedo()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this.handleRedo();
      return;
    }

    if (!this.canUndo()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.handleUndo();
  };

  handleTemplateNext = async () => {
    const { selectedTemplateId, agentTemplates } = this.state;
    if (!selectedTemplateId) return;

    this.setState({ isTemplatesLoading: true });
    try {
      const template = agentTemplates.find((t) => t.id === selectedTemplateId);
      if (template?.agentModel) {
        const templateData =
          typeof template.agentModel === "string" ? JSON.parse(template.agentModel) : template.agentModel;
        const processType = this.normalizeProcessType(
          (templateData as any).processType ?? (templateData as any).process_type
        );
        const managerAgent = this.normalizeManagerAgent(
          (templateData as any).managerAgent ?? (templateData as any).manager_agent
        );
        const { nodes, edges } = await generateAIAgentNodesAndEdges(templateData.crewAgents || []);
        this.setState({
          nodes: this.withSelection(nodes, undefined),
          edges,
          crew_inputs: templateData.crew_inputs || [],
          crew_custom_data_types: templateData.crew_custom_data_types || [],
          processType,
          managerAgent,
          isCreatingCustomTemplate: true,
          selectedAgentId: undefined
        });
      } else {
        this.setState({
          isCreatingCustomTemplate: true,
          processType: "sequential",
          managerAgent: undefined
        });
      }
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    } finally {
      this.setState({ isTemplatesLoading: false });
    }
  };

  shouldShowTemplateSelection = (): boolean => {
    const { actionToEdit } = this.props;
    const { isCreatingCustomTemplate } = this.state;
    // Show template selection when:
    // - Not editing an existing action
    // - Not creating a custom template (from scratch workflow hasn't started)
    return !actionToEdit && !isCreatingCustomTemplate;
  };

  handleUpdateCustomDataTypes = (customDataTypes: ICrewCustomDataType[]) => {
    const hasChanged = !_.isEqual(this.state.crew_custom_data_types, customDataTypes);
    if (hasChanged) {
      this.pushToHistory();
    }
    this.setState({
      crew_custom_data_types: customDataTypes,
      hasManualChanges: this.state.hasManualChanges || hasChanged
    });
  };

  handleFilterTemplates = (selectedFrameworkIds: string[]) => {
    this.setState({
      selectedFrameworkIds
    });
  };

  handleFilterByTags = (selectedTags: string[]) => {
    this.setState({
      selectedTags
    });
  };

  handleSearchTemplates = (searchTerm: string) => {
    this.setState({
      searchTerm
    });
  };

  getUniqueFrameworks = (): IAiAgentModel[] => {
    return this.state.agentModels.filter((model) =>
      this.state.agentTemplates.some((template) => template.modelId === model.id)
    );
  };

  getUniqueTags = (): string[] => {
    const tagsSet = new Set<string>();
    this.state.agentTemplates.forEach((template) => {
      const templateTags = (template as any).tags || [];
      templateTags.forEach((tag: string) => tagsSet.add(tag));
    });
    return Array.from(tagsSet).sort();
  };

  /** hierarchical vs sequential, read off the agent's own config. */
  getAgentProcessType = (record: IActionDefinitionDto): "hierarchical" | "sequential" | null => {
    const info = this.props.sd.getStringifiedAiAgentInfo(record.aiAgentInfo);
    const raw: unknown = info?.processType;
    if (raw === undefined || raw === null) return null;
    return Number(raw) === 1 ? "hierarchical" : "sequential";
  };

  renderAgentRecentsTable = () => {
    const aiAgents: IActionDefinitionDto[] = (this.props.sd?.actionDefinitions || []).filter(
      (a: IActionDefinitionDto) => a.actionType === EDatasourceType.AIAgent
    );

    const columns: KuikaListTableColumn<IActionDefinitionDto>[] = [
      {
        id: "name",
        header: () => "Name",
        accessorFn: (row: IActionDefinitionDto) => row.name,
        cell: (row: IActionDefinitionDto) => (
          <span
            style={
              {
                "--kuika-list-table-icon-bg": "var(--blue-1)",
                "--kuika-list-table-icon-color": "var(--accent-fg)"
              } as React.CSSProperties
            }
          >
            <KuikaListTableNameCell
              name={row.name}
              icon={<KuikaSvg type="datasource-icons" name="ai-agent" width={12} height={12} />}
            />
          </span>
        )
      },
      {
        id: "processType",
        header: () => "Process",
        width: 160,
        accessorFn: (row: IActionDefinitionDto) => this.getAgentProcessType(row) ?? "",
        cell: (row: IActionDefinitionDto) => {
          const processType = this.getAgentProcessType(row);
          if (!processType) return "—";
          return (
            <KuikaBadge
              type="label"
              size="small"
              color={processType === "hierarchical" ? "orange" : "blue"}
              content={processType}
            />
          );
        }
      },
      {
        id: "status",
        header: () => "Status",
        width: 120,
        accessorFn: (row: IActionDefinitionDto) => row.aiActionStatus ?? EAiActionStatus.Published,
        cell: (row: IActionDefinitionDto) => {
          const isDraft: boolean = (row.aiActionStatus ?? EAiActionStatus.Published) === EAiActionStatus.Draft;
          return (
            <KuikaListTableStatusCell label={isDraft ? "Draft" : "Published"} color={isDraft ? "yellow" : "green"} />
          );
        }
      },
      {
        id: "created",
        header: () => "Created",
        width: 220,
        // Sorted by WHEN: the cell's caption is the timestamp.
        accessorFn: (row: IActionDefinitionDto) => (row.createdAt ? new Date(row.createdAt).getTime() : 0),
        cell: (row: IActionDefinitionDto) => {
          const firstName: string = row.createdUser?.firstName ?? "";
          const lastName: string = row.createdUser?.lastName ?? "";
          const fullName: string = [firstName, lastName].filter(Boolean).join(" ");
          const initials: string = `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase();
          return (
            <KuikaListTableUserCell
              caption={row.createdAt ? KMainFunctions.formatRelativeTime(row.createdAt) : undefined}
              name={fullName || undefined}
              photoUrl={row.createdUser?.profilePhotoUrl || undefined}
              initials={initials || undefined}
            />
          );
        }
      }
    ];

    return (
      <div className="ai-action-templates-tab ai-action-templates-tab--without-filters">
        <KuikaListTable<IActionDefinitionDto>
          data={aiAgents}
          columns={columns}
          rowKey={(row: IActionDefinitionDto) => row.id}
          emptyTitle="No AI Agents yet"
          emptyDescription="Start from a template or create one from a blank."
        />
      </div>
    );
  };

  renderCreateFromScratch = () => {
    const isSelected: boolean = this.state.selectedTemplateId === "custom";
    return (
      <KuikaCreateCardRow>
        <KuikaCreateCard
          className={isSelected ? "kuika-create-card--selected" : undefined}
          title="Create from a blank"
          description="Start with a blank canvas and build your workflow step by step."
          icon={<KuikaSvg type="datasource-icons" name="ai-agent" width={24} height={24} />}
          iconBackground="var(--blue-1)"
          iconColor="var(--accent-fg)"
          onClick={this.handleCreateFromScratchClick}
        />
      </KuikaCreateCardRow>
    );
  };

  getAIAgentActions = (): IActionDefinitionDto[] => {
    return (this.props.sd?.actionDefinitions || []).filter((a) => a.actionType === EDatasourceType.AIAgent);
  };

  // KOA-16736: Get all actions eligible to be exposed as KAction MCP tools
  // KOA-16736: Get all actions eligible as KAction MCP tools.
  // Must match backend IsServerSideAction types that ToCs() can generate code for.
  // Excludes: SystemJSFunctions (client-side), AIAgents (recursion), auth providers,
  //   Blockly/MQTT/BLE (special-purpose).
  getAvailableKActions = (): IActionDefinitionDto[] => {
    const eligibleTypes: EDatasourceType[] = [
      // Database actions
      EDatasourceType.ManagedDb,
      EDatasourceType.CustomDb,
      EDatasourceType.MsSql,
      EDatasourceType.Oracle,
      EDatasourceType.ManagedDbOracle,
      EDatasourceType.Postgre,
      EDatasourceType.ManagedDbPostgre,
      // Code actions
      EDatasourceType.CSharpFunctions,
      EDatasourceType.SystemCSFunctions,
      // API actions
      EDatasourceType.RestApi,
      EDatasourceType.RestApiWOSwagger,
      EDatasourceType.OData,
      EDatasourceType.SAP,
      // AI actions (nested LLM calls — technically works)
      EDatasourceType.AIActions
    ];
    return (this.props.sd?.actionDefinitions || []).filter(
      (a) => eligibleTypes.includes(a.actionType) && !a.isDeprecated
    );
  };

  hasCreatedAIAgentBefore = (): boolean => {
    return this.getAIAgentActions().length > 0;
  };

  closeScratchEmptyState = () => {
    this.setState({ isScratchEmptyStateVisible: false });
  };

  createStarterAgents = (processType: CrewProcessType): IStarterAgentFlowData => {
    if (processType === "hierarchical") {
      // KOA-14774 hierarchical model:
      // - Sub-agents are pure capability profiles (role/goal/backstory/model/tools).
      //   They do NOT have tasks, output_format, or memoryMode -- the manager owns
      //   the task and delegates at runtime.
      // - The manager owns the crew's single task, output_format, and memoryMode.
      const researchSpecialist = {
        name: "Research Specialist",
        role: "Research Agent",
        goal: "Collect relevant source data when the manager asks for research.",
        backstory: "Focused on finding reliable information quickly and capturing credible source URLs.",
        model: "gpt-5-mini",
        tools: [{ name: "SerperDevTool" }, { name: "ScrapeWebsiteTool" }]
      } as ICrewAgent;

      const analysisSpecialist = {
        name: "Analysis Specialist",
        role: "Analysis Agent",
        goal: "Analyze findings and extract insights when the manager asks for analysis.",
        backstory: "Turns raw information into practical decisions with traceable evidence.",
        model: "gpt-5.4",
        tools: [{ name: "CodeInterpreterTool" }]
      } as ICrewAgent;

      const deliverySpecialist = {
        name: "Delivery Specialist",
        role: "Delivery Agent",
        goal: "Prepare a polished final response when the manager asks for delivery.",
        backstory: "Creates clear, audience-ready deliverables from validated content.",
        model: "gpt-5.4",
        tools: [{ name: "FileWriterTool" }]
      } as ICrewAgent;

      return {
        agents: [researchSpecialist, analysisSpecialist, deliverySpecialist],
        managerAgent: {
          name: "Crew Manager",
          role: "Hierarchical Crew Manager",
          goal: "Coordinate research, analysis, and delivery agents to produce the final response.",
          backstory:
            "You orchestrate a research, analysis, and delivery team. Only assign other agents to do the task; do not execute work yourself. Delegate to the Research Specialist first to gather evidence, then to the Analysis Specialist to produce recommendations, then to the Delivery Specialist to finalize the response.",
          model: "e6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c", // default model is gpt-5.4
          memoryMode: ECrewAiAgentMemoryMode.Shared,
          task: {
            description:
              "Produce a final response for {target_audience} about {topic}. Research evidence that supports or challenges {success_criteria}, analyze it into recommendations, and deliver the final answer in a tone aligned with {delivery_tone}.",
            expected_output:
              "A polished final response aligned with the target audience, supported by evidence and key takeaways for quick review.",
            guardrail:
              "The final response must be grounded in evidence gathered by the research agent, aligned with the requested tone, and ready to deliver without cleanup.",
            guardrailMaxRetryLimit: 2,
            output_format: {
              final_response: "str (Polished response that can be delivered directly to the target audience)",
              key_takeaways: "List[str] (Highlights that justify the final response)",
              sources: "List[ResearchSource] (Credible sources used to support the findings)"
            }
          }
        },
        crewInputs: [
          { parameter_name: "topic", parameter_format: "str" },
          { parameter_name: "target_audience", parameter_format: "str" },
          { parameter_name: "success_criteria", parameter_format: "str" },
          { parameter_name: "delivery_tone", parameter_format: "str" }
        ],
        crewCustomDataTypes: [
          {
            type_name: "ResearchSource",
            properties: {
              title: "str (Source title)",
              url: "str (Source URL)",
              reason: "str (Why this source matters to the final response)"
            }
          }
        ]
      };
    }

    const inputSpecialist = {
      name: "Agent 1",
      role: "Input Specialist",
      goal: "Prepare and validate incoming input.",
      backstory: "Ensures the workflow starts from clean context.",
      task: {
        description:
          "Validate the incoming request for {user_request}, preserve the requested {tone}, and normalize it into a structure the next agent can process reliably.",
        expected_output: "Structured input payload with validated request context.",
        guardrail:
          "Do not invent missing requirements. If the request is incomplete, make the gap explicit in the output.",
        guardrailMaxRetryLimit: 2,
        output_format: {
          request_summary: "str (Clean summary of the validated request)",
          constraints: "List[str] (Important limits or requirements the workflow must respect)",
          target_format: "str (Expected response format to preserve downstream)"
        }
      },
      model: "gpt-5-mini",
      tools: [{ name: "SerperDevTool" }]
    } as ICrewAgent;
    inputSpecialist.memoryMode = ECrewAiAgentMemoryMode.Shared;

    const processingSpecialist = {
      name: "Agent 2",
      role: "Processing Specialist",
      goal: "Process structured input and produce core result.",
      backstory: "Handles the main execution stage.",
      task: {
        description:
          "Process the validated request summary and generate the main working output. Use the request constraints to keep the answer aligned with the user goal.",
        expected_output: "Processed intermediate output with actionable content.",
        guardrail: "Keep the output directly relevant to the validated request summary and avoid unsupported claims.",
        guardrailMaxRetryLimit: 2,
        output_format: {
          draft_answer: "str (Primary draft generated from the structured input)",
          supporting_points: "List[str] (Key points that justify the draft answer)"
        }
      },
      model: "gpt-5.4",
      tools: [{ name: "CodeInterpreterTool" }]
    } as ICrewAgent;
    processingSpecialist.memoryMode = ECrewAiAgentMemoryMode.Shared;

    const finalizationSpecialist = {
      name: "Agent 3",
      role: "Finalization Specialist",
      goal: "Finalize result into delivery format.",
      backstory: "Produces concise, final-ready outputs.",
      task: {
        description:
          "Finalize the draft answer into the requested {target_format}. Preserve the requested {tone} and make the response ready to deliver.",
        expected_output: "Final output response in the correct format.",
        guardrail:
          "Ensure the final response matches the requested format and is ready for direct delivery without cleanup.",
        guardrailMaxRetryLimit: 2,
        output_format: {
          final_response: "str (Completed response ready for delivery)",
          checklist: "List[str] (Quick verification items for the final result)"
        }
      },
      model: "gpt-5.4",
      tools: [{ name: "FileWriterTool" }]
    } as ICrewAgent;
    finalizationSpecialist.memoryMode = ECrewAiAgentMemoryMode.Shared;

    return {
      agents: [inputSpecialist, processingSpecialist, finalizationSpecialist],
      crewInputs: [
        { parameter_name: "user_request", parameter_format: "str" },
        { parameter_name: "tone", parameter_format: "str" },
        { parameter_name: "target_format", parameter_format: "str" }
      ],
      crewCustomDataTypes: []
    };
  };

  buildInitialAgentsForProcessType = async (
    processType: CrewProcessType
  ): Promise<{
    nodes: IElkNode[];
    edges: any[];
    crewInputs: ICrewInput[];
    crewCustomDataTypes: ICrewCustomDataType[];
    managerAgent?: ICrewManagerAgent;
  }> => {
    const starterFlowData = this.createStarterAgents(processType);
    let starterAgents = starterFlowData.agents;
    let starterManagerAgent = starterFlowData.managerAgent;

    try {
      const response = await DatasourceService.GetAiModels();
      const instructionModels = (response.data || [])
        .filter((model: any) => model?.id && model?.name)
        .filter((model: any) => model.status === EAiModelStatus.Active);

      starterAgents = starterFlowData.agents.map((agent) => {
        if (typeof agent.model !== "string" || !agent.model.trim() || this.isGuidValue(agent.model)) {
          return agent;
        }

        const matchedModel = instructionModels.find(
          (model: any) =>
            model.id === agent.model || String(model.name).toLowerCase() === String(agent.model).toLowerCase()
        );

        if (!matchedModel?.id) {
          return agent;
        }

        return {
          ...agent,
          model: matchedModel.id
        };
      });

      if (
        starterManagerAgent &&
        typeof starterManagerAgent.model === "string" &&
        starterManagerAgent.model.trim() &&
        !this.isGuidValue(starterManagerAgent.model)
      ) {
        const matchedManagerModel = instructionModels.find(
          (model: any) =>
            model.id === starterManagerAgent!.model ||
            String(model.name).toLowerCase() === String(starterManagerAgent!.model).toLowerCase()
        );
        if (matchedManagerModel?.id) {
          starterManagerAgent = { ...starterManagerAgent, model: matchedManagerModel.id };
        }
      }
    } catch {
      // Keep starter agents usable even if model lookup fails.
    }

    const generatedFlow = await generateAIAgentNodesAndEdges(starterAgents);

    return {
      nodes: generatedFlow.nodes,
      edges: processType === "hierarchical" ? [] : generatedFlow.edges,
      crewInputs: starterFlowData.crewInputs,
      crewCustomDataTypes: starterFlowData.crewCustomDataTypes,
      managerAgent: starterManagerAgent
    };
  };

  getWalkthroughSteps = (processType: CrewProcessType): IProcessTypeWalkthroughStep[] => {
    if (processType === "hierarchical") {
      return [
        {
          id: "overview",
          stepLabel: "STEP 1 / 7",
          title: "Hierarchical Process",
          description: "A manager agent coordinates workers and controls overall output quality.",
          placement: "center"
        },
        {
          id: "manager-node",
          stepLabel: "STEP 2 / 7",
          title: "Manager Node",
          description:
            "The manager plans execution, delegates tasks, and merges worker outputs. Pick a stronger model for the manager when you need better reasoning and quality control.",
          placement: "manager",
          highlightSelector: ".react-flow__node-manager"
        },
        {
          id: "workers",
          stepLabel: "STEP 3 / 7",
          title: "Worker Agents",
          description:
            "Workers are specialized by role. Keep model choice task-specific (lighter model for retrieval/prep, stronger model for reasoning), assign only necessary tools (search, code, file), and enable memory when a worker must keep context across delegated steps.",
          placement: "workers",
          highlightSelector: ".react-flow__node-elk"
        },
        {
          id: "agent-sidebar",
          stepLabel: "STEP 4 / 7",
          title: "Worker Agent Sidebar",
          description:
            "Select a worker to open its sidebar. This tutorial sample is intentionally filled so you can inspect a real setup instead of empty placeholders: Agent Info shows who the worker is, Tools shows what it can use, Task Parameters explains the task description and guardrails, Return Types shows the structure the worker sends back, Inputs highlights variables like {topic} and {target_audience}, and Custom Data Types shows reusable objects such as source records. Read these sections top to bottom to understand one worker from input to output.",
          placement: "sidebar",
          highlightSelector: "[data-ai-agent-walkthrough='sidebar']"
        },
        {
          id: "connections",
          stepLabel: "STEP 5 / 7",
          title: "Manager Connections",
          description:
            "Workers connect to the manager via the orange colored edges in a star topology instead of connecting to each other like in sequential processes, thus making agents independent.",
          placement: "connections",
          highlightSelector: ".react-flow__edge--manager"
        },
        {
          id: "params",
          stepLabel: "STEP 6 / 7",
          title: "Required Manager Settings",
          description:
            "In Params, confirm hierarchical process type, set manager model, and tune manager memory/delegation. These settings directly control how workers are coordinated.",
          placement: "sidebar",
          highlightSelector: "[data-ai-agent-walkthrough='sidebar']"
        },
        {
          id: "validate",
          stepLabel: "STEP 7 / 7",
          title: "Validate and Publish",
          description: "Use TEST and UPDATE to validate manager coordination before finalizing.",
          placement: "actions",
          highlightSelector: "[data-ai-agent-walkthrough='actions']"
        }
      ];
    }

    return [
      {
        id: "overview",
        stepLabel: "STEP 1 / 6",
        title: "Sequential Process",
        description: "Agents execute step-by-step, passing output downstream in order.",
        placement: "center"
      },
      {
        id: "flow",
        stepLabel: "STEP 2 / 6",
        title: "Flow Direction",
        description: "This chain defines execution order from first agent to last agent.",
        placement: "canvas",
        highlightSelector: "[data-ai-agent-walkthrough='canvas']"
      },
      {
        id: "responsibilities",
        stepLabel: "STEP 3 / 6",
        title: "Agent Responsibilities",
        description:
          "Define one clear responsibility per agent and align model/tools to that role. Avoid overlap so each handoff in the chain stays predictable and easy to debug.",
        placement: "workers",
        highlightSelector: ".react-flow__node-elk"
      },
      {
        id: "agent-sidebar",
        stepLabel: "STEP 4 / 6",
        title: "Agent Sidebar",
        description:
          "Click an agent to open its sidebar. This sample is populated so you can learn each section without guessing: Agent Info defines the role, Tools limits what the agent can use, Task Parameters contains the task description and guardrails, Return Types defines the output schema, Inputs shows variables such as {user_request}, {tone}, and {target_format}, and Custom Data Types can define reusable objects when needed. Follow the sections in order to understand how one agent is configured from input to output.",
        placement: "sidebar",
        highlightSelector: "[data-ai-agent-walkthrough='sidebar']"
      },
      {
        id: "params",
        stepLabel: "STEP 5 / 6",
        title: "Tools and Parameters",
        description:
          "Open Params to configure model, memory, task guardrails, tools, and output format for the selected agent. Keep tools minimal and outputs structured for reliable downstream chaining.",
        placement: "sidebar",
        highlightSelector: "[data-ai-agent-walkthrough='sidebar']"
      },
      {
        id: "validate",
        stepLabel: "STEP 6 / 6",
        title: "Validate and Publish",
        description: "Run TEST, iterate, and finalize with UPDATE once the flow behaves correctly.",
        placement: "actions",
        highlightSelector: "[data-ai-agent-walkthrough='actions']"
      }
    ];
  };

  applyProcessTypeWalkthroughHighlight = (attempt: number = 0) => {
    this.clearProcessTypeWalkthroughHighlight();

    const step = this.state.processTypeWalkthroughSteps[this.state.processTypeWalkthroughStepIndex];
    if (!step?.highlightSelector) {
      this.setState({ processTypeWalkthroughSpotlight: undefined });
      return;
    }

    if (step.id === "agent-sidebar") {
      const firstAgentId = this.state.nodes[0]?.id;
      this.setState((prev) => ({
        rightPanelTab: "params",
        selectedAgentId: firstAgentId,
        nodes: this.withSelection(prev.nodes, firstAgentId),
        walkthroughPreferredAccordionKey:
          prev.walkthroughPreferredAccordionKey === "allAgentSections" ? "allAgentSections_" : "allAgentSections"
      }));
    } else if (step.id === "params") {
      if (this.state.processType === "hierarchical") {
        this.setState((prev) => ({
          rightPanelTab: "params",
          selectedAgentId: undefined,
          nodes: this.withSelection(prev.nodes, undefined),
          walkthroughPreferredAccordionKey:
            prev.walkthroughPreferredAccordionKey === "allAgentSections" ? "allAgentSections_" : "allAgentSections"
        }));
      } else {
        const firstAgentId = this.state.nodes[0]?.id;
        const shouldUpdateSequentialParamsState =
          this.state.rightPanelTab !== "params" ||
          this.state.selectedAgentId !== firstAgentId ||
          this.state.walkthroughPreferredAccordionKey !== "selectedAgent";

        if (step.id === "params") {
          this.setState((prev) => ({
            rightPanelTab: "params",
            selectedAgentId: undefined,
            nodes: this.withSelection(prev.nodes, undefined),
            walkthroughPreferredAccordionKey:
              prev.walkthroughPreferredAccordionKey === "allAgentSections" ? "allAgentSections_" : "allAgentSections"
          }));
        } else if (shouldUpdateSequentialParamsState) {
          this.setState((prev) => ({
            rightPanelTab: "params",
            selectedAgentId: firstAgentId,
            nodes: this.withSelection(prev.nodes, firstAgentId),
            walkthroughPreferredAccordionKey: "selectedAgent"
          }));
        }
      }
    } else if (this.state.walkthroughPreferredAccordionKey) {
      this.setState({ walkthroughPreferredAccordionKey: undefined });
    }

    const targets = Array.from(document.querySelectorAll(step.highlightSelector));
    if (!targets.length) {
      this.setState({ processTypeWalkthroughSpotlight: undefined });
      return;
    }

    let elementsToHighlight: Element[] = [...targets];

    let validRects: DOMRect[] = [];

    if (step.id === "connections") {
      const managerEdges = Array.from(
        document.querySelectorAll(".kuika-ai-agent__workflow-area .react-flow__edge.react-flow__edge--manager")
      );
      const managerEdgePaths = Array.from(
        document.querySelectorAll(
          ".kuika-ai-agent__workflow-area .react-flow__edge.react-flow__edge--manager .react-flow__edge-path"
        )
      );

      elementsToHighlight = [...managerEdges, ...managerEdgePaths];

      validRects = managerEdgePaths
        .map((element) => element.getBoundingClientRect())
        .filter((rect) => rect.width > 0 || rect.height > 0);

      if (!validRects.length) {
        validRects = managerEdges
          .map((element) => element.getBoundingClientRect())
          .filter((rect) => rect.width > 0 || rect.height > 0);
      }
    } else {
      const primaryTargetRect = targets[0].getBoundingClientRect();
      if (primaryTargetRect.width > 0 || primaryTargetRect.height > 0) {
        validRects = [primaryTargetRect];
      }
    }

    if (elementsToHighlight.length) {
      const uniqueElements = Array.from(new Set(elementsToHighlight));
      uniqueElements.forEach((target) => target.classList.add("ai-agent-walkthrough__highlight-target"));
      this.highlightedWalkthroughElements = uniqueElements;
    }

    if (!validRects.length) {
      if (step.id === "connections" && attempt < 2) {
        window.setTimeout(() => this.applyProcessTypeWalkthroughHighlight(attempt + 1), 80);
        return;
      }
      this.setState({ processTypeWalkthroughSpotlight: undefined });
      return;
    }

    const rect = validRects.reduce(
      (acc, currentRect) => ({
        top: Math.min(acc.top, currentRect.top),
        left: Math.min(acc.left, currentRect.left),
        right: Math.max(acc.right, currentRect.right),
        bottom: Math.max(acc.bottom, currentRect.bottom)
      }),
      {
        top: validRects[0].top,
        left: validRects[0].left,
        right: validRects[0].right,
        bottom: validRects[0].bottom
      }
    );

    const padding = 10;

    this.setState({
      processTypeWalkthroughSpotlight: {
        top: Math.max(0, rect.top - padding),
        left: Math.max(0, rect.left - padding),
        right: Math.min(window.innerWidth, rect.right + padding),
        bottom: Math.min(window.innerHeight, rect.bottom + padding)
      }
    });
  };

  clearProcessTypeWalkthroughHighlight = (shouldResetSpotlightState: boolean = true) => {
    if (!this.highlightedWalkthroughElements.length) {
      if (shouldResetSpotlightState && this.state.processTypeWalkthroughSpotlight) {
        this.setState({ processTypeWalkthroughSpotlight: undefined });
      }
      return;
    }

    this.highlightedWalkthroughElements.forEach((element) => {
      element.classList.remove("ai-agent-walkthrough__highlight-target");
    });
    this.highlightedWalkthroughElements = [];
    if (shouldResetSpotlightState) {
      this.setState({ processTypeWalkthroughSpotlight: undefined });
    }
  };

  startProcessTypeWalkthrough = (processType: CrewProcessType) => {
    const processTypeWalkthroughSteps = this.getWalkthroughSteps(processType);
    this.setState(
      {
        showProcessTypeWalkthrough: true,
        processTypeWalkthroughSteps,
        processTypeWalkthroughStepIndex: 0,
        processTypeWalkthroughSpotlight: undefined,
        walkthroughPreferredAccordionKey: undefined
      },
      () => {
        window.requestAnimationFrame(() => this.applyProcessTypeWalkthroughHighlight());
      }
    );
  };

  clearTutorialPreloadCanvas = () => {
    this.setState({
      nodes: this.withSelection([], undefined),
      edges: [],
      crew_inputs: [],
      crew_custom_data_types: [],
      selectedAgentId: undefined,
      managerAgent: undefined,
      crewMemoryOptions: undefined,
      hasManualChanges: false,
      rightPanelTab: "chat",
      walkthroughPreferredAccordionKey: undefined
    });
  };

  completeProcessTypeWalkthrough = () => {
    this.clearProcessTypeWalkthroughHighlight();
    this.setState(
      {
        showProcessTypeWalkthrough: false,
        processTypeWalkthroughSteps: [],
        processTypeWalkthroughStepIndex: 0,
        processTypeWalkthroughSpotlight: undefined,
        walkthroughPreferredAccordionKey: undefined
      },
      () => {
        this.clearTutorialPreloadCanvas();
      }
    );
  };

  skipProcessTypeWalkthrough = () => {
    this.completeProcessTypeWalkthrough();
  };

  getStartedProcessTypeWalkthrough = () => {
    this.completeProcessTypeWalkthrough();
  };

  nextProcessTypeWalkthroughStep = () => {
    const { processTypeWalkthroughStepIndex, processTypeWalkthroughSteps } = this.state;
    const isLastStep = processTypeWalkthroughStepIndex >= processTypeWalkthroughSteps.length - 1;

    if (isLastStep) {
      this.completeProcessTypeWalkthrough();
      return;
    }

    this.setState(
      {
        processTypeWalkthroughStepIndex: processTypeWalkthroughStepIndex + 1
      },
      () => {
        window.requestAnimationFrame(() => this.applyProcessTypeWalkthroughHighlight());
      }
    );
  };

  previousProcessTypeWalkthroughStep = () => {
    const { processTypeWalkthroughStepIndex } = this.state;
    if (processTypeWalkthroughStepIndex <= 0) {
      return;
    }

    this.setState(
      {
        processTypeWalkthroughStepIndex: processTypeWalkthroughStepIndex - 1
      },
      () => {
        window.requestAnimationFrame(() => this.applyProcessTypeWalkthroughHighlight());
      }
    );
  };

  startBuildingFromScratch = async (processType: CrewProcessType) => {
    this.setTemplateSelected("custom", "AI_Agent");

    const { nodes, edges, crewInputs, crewCustomDataTypes, managerAgent } =
      await this.buildInitialAgentsForProcessType(processType);

    this.setState({
      isCreatingCustomTemplate: true,
      isScratchSidebarVisible: false,
      isScratchEmptyStateVisible: false,
      showProcessTypeSelectionModal: false,
      processType,
      managerAgent: managerAgent ?? undefined,
      crewMemoryOptions: undefined,
      nodes: this.withSelection(nodes, undefined),
      edges,
      crew_inputs: crewInputs,
      crew_custom_data_types: crewCustomDataTypes,
      selectedAgentId: undefined,
      undoStack: [],
      redoStack: [],
      hasManualChanges: false,
      viewMode: "edit",
      isCanvasPanEnabled: true,
      showProcessTypeWalkthrough: false,
      processTypeWalkthroughSteps: [],
      processTypeWalkthroughStepIndex: 0,
      processTypeWalkthroughSpotlight: undefined,
      walkthroughPreferredAccordionKey: undefined
    });
  };

  openProcessTypeSelectionModal = () => {
    this.clearProcessTypeWalkthroughHighlight();
    this.setTemplateSelected("custom", "AI_Agent");
    this.setState({
      isCreatingCustomTemplate: true,
      isScratchSidebarVisible: false,
      isScratchEmptyStateVisible: false,
      showProcessTypeSelectionModal: true,
      pendingCustomProcessType: undefined,
      processType: "sequential",
      managerAgent: undefined,
      crewMemoryOptions: undefined,
      nodes: this.withSelection([], undefined),
      edges: [],
      crew_inputs: [],
      crew_custom_data_types: [],
      selectedAgentId: undefined,
      isCanvasPanEnabled: true,
      showProcessTypeWalkthrough: false,
      processTypeWalkthroughSteps: [],
      processTypeWalkthroughStepIndex: 0,
      processTypeWalkthroughSpotlight: undefined,
      walkthroughPreferredAccordionKey: undefined
    });
  };

  closeProcessTypeSelectionModal = () => {
    this.setState({
      showProcessTypeSelectionModal: false,
      isCreatingCustomTemplate: false,
      selectedTemplateId: undefined,
      processType: "sequential",
      managerAgent: undefined,
      nodes: this.withSelection([], undefined),
      edges: [],
      crew_inputs: [],
      crew_custom_data_types: [],
      selectedAgentId: undefined,
      isScratchSidebarVisible: false,
      isScratchEmptyStateVisible: false,
      hasManualChanges: false
    });
    this.clearProcessTypeWalkthroughHighlight();
  };

  setPendingCustomProcessType = (processType: CrewProcessType) => {
    this.setState({ pendingCustomProcessType: processType });
  };

  confirmCustomProcessTypeSelection = async () => {
    const selectedProcessType = this.state.pendingCustomProcessType;
    if (!selectedProcessType) return;

    const hasCreatedSelectedProcessTypeBefore = this.hasCreatedProcessTypeBefore(selectedProcessType);

    if (hasCreatedSelectedProcessTypeBefore) {
      // Experienced user: start with a blank canvas instead of sample agents
      this.setTemplateSelected("custom", "AI_Agent");
      this.setState({
        isCreatingCustomTemplate: true,
        isScratchSidebarVisible: false,
        isScratchEmptyStateVisible: false,
        showProcessTypeSelectionModal: false,
        processType: selectedProcessType,
        managerAgent:
          selectedProcessType === "hierarchical" ? { model: "e6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c" } : undefined,
        nodes: this.withSelection([], undefined),
        edges: [],
        crew_inputs: [],
        crew_custom_data_types: [],
        selectedAgentId: undefined,
        undoStack: [],
        redoStack: [],
        hasManualChanges: false,
        viewMode: "edit",
        isCanvasPanEnabled: true,
        rightPanelTab: "chat"
      });
    } else {
      // First time: show starter agents with walkthrough
      await this.startBuildingFromScratch(selectedProcessType);
      this.startProcessTypeWalkthrough(selectedProcessType);
    }
  };

  renderProcessTypeWalkthrough = () => {
    const {
      showProcessTypeWalkthrough,
      processTypeWalkthroughSteps,
      processTypeWalkthroughStepIndex,
      processTypeWalkthroughSpotlight
    } = this.state;
    if (!showProcessTypeWalkthrough || !processTypeWalkthroughSteps.length) {
      return null;
    }

    const currentStep = processTypeWalkthroughSteps[processTypeWalkthroughStepIndex];
    const isLastWalkthroughStep = processTypeWalkthroughStepIndex === processTypeWalkthroughSteps.length - 1;

    const CARD_WIDTH = 300;
    const GAP = 16;

    let cardStyle: React.CSSProperties;
    let cardFlipped = false;

    if (processTypeWalkthroughSpotlight) {
      const spotlightCenterX = (processTypeWalkthroughSpotlight.left + processTypeWalkthroughSpotlight.right) / 2;
      const spotlightMidY = Math.round(
        (processTypeWalkthroughSpotlight.top + processTypeWalkthroughSpotlight.bottom) / 2
      );

      if (spotlightCenterX > window.innerWidth / 2) {
        // Spotlight in right half → card goes to the LEFT of the spotlight
        cardFlipped = true;
        cardStyle = {
          left: Math.max(GAP, processTypeWalkthroughSpotlight.left - CARD_WIDTH - GAP),
          top: spotlightMidY,
          transform: "translateY(-50%)"
        };
      } else {
        // Spotlight in left half → card goes to the RIGHT of the spotlight
        cardStyle = {
          left: Math.min(processTypeWalkthroughSpotlight.right + GAP, window.innerWidth - CARD_WIDTH - GAP),
          top: spotlightMidY,
          transform: "translateY(-50%)"
        };
      }
    } else {
      cardStyle = {
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
      };
    }

    const cardClassName = [
      "ai-agent-walkthrough__card",
      !processTypeWalkthroughSpotlight ? "ai-agent-walkthrough__card--center" : "",
      cardFlipped ? "ai-agent-walkthrough__card--flipped" : ""
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className="ai-agent-walkthrough">
        {processTypeWalkthroughSpotlight ? (
          <div
            className="ai-agent-walkthrough__spotlight"
            style={{
              top: processTypeWalkthroughSpotlight.top,
              left: processTypeWalkthroughSpotlight.left,
              width: processTypeWalkthroughSpotlight.right - processTypeWalkthroughSpotlight.left,
              height: processTypeWalkthroughSpotlight.bottom - processTypeWalkthroughSpotlight.top
            }}
          />
        ) : (
          <div className="ai-agent-walkthrough__backdrop" />
        )}
        <div className={cardClassName} style={cardStyle}>
          <div className="ai-agent-walkthrough__header">
            <div className="ai-agent-walkthrough__header-left">
              <div className="ai-agent-walkthrough__step-label">{currentStep.stepLabel}</div>
            </div>
            <KuikaButton type="tertiary" size="sm" isIcon onClick={this.skipProcessTypeWalkthrough}>
              <KuikaSvg type="common" name="x" width={16} height={16} />
            </KuikaButton>
          </div>
          <div className="ai-agent-walkthrough__title">{currentStep.title}</div>
          <div className="ai-agent-walkthrough__description">{currentStep.description}</div>
          <div className="ai-agent-walkthrough__footer">
            <div className="ai-agent-walkthrough__actions">
              <KuikaButton
                type="tertiary"
                size="sm"
                onClick={
                  isLastWalkthroughStep ? this.getStartedProcessTypeWalkthrough : this.skipProcessTypeWalkthrough
                }
              >
                {isLastWalkthroughStep ? "GET STARTED" : "SKIP"}
              </KuikaButton>
            </div>
            <div className="ai-agent-walkthrough__nav">
              <KuikaButton
                type="tertiary"
                size="sm"
                isIcon
                onClick={this.previousProcessTypeWalkthroughStep}
                disabled={processTypeWalkthroughStepIndex === 0}
              >
                <KuikaSvg type="arrows" name="chevron-left" width={20} height={20} />
              </KuikaButton>
              <KuikaButton
                type="tertiary"
                size="sm"
                isIcon
                onClick={this.nextProcessTypeWalkthroughStep}
                disabled={isLastWalkthroughStep}
              >
                <KuikaSvg type="arrows" name="chevron-right" width={20} height={20} />
              </KuikaButton>
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleCreateFromScratchClick = () => {
    if (this.hasCreatedAIAgentBefore()) {
      this.setState({ isScratchSidebarVisible: true, isScratchEmptyStateVisible: false });
      return;
    }

    this.setState({ isScratchEmptyStateVisible: true, isScratchSidebarVisible: false });
  };

  renderScratchSidebar = () => {
    if (!this.state.isScratchSidebarVisible) return null;

    const closeScratch = () => this.setState({ isScratchSidebarVisible: false });

    return (
      <div className="ai-template-detail-overlay" onClick={closeScratch}>
        <div className="ai-template-detail-panel" onClick={(e) => e.stopPropagation()}>
          <div className="ai-template-detail-panel__header">
            <div className="ai-template-detail-panel__header-left">
              <KuikaButton type="tertiary" size="sm" isIcon onClick={closeScratch}>
                <KuikaSvg type="common" name="x" width={18} height={18} />
              </KuikaButton>
            </div>
            <div className="ai-template-detail-panel__header-title">
              <p className="ai-template-detail-panel__title">Build from Scratch</p>
            </div>
          </div>
          <div className="ai-template-detail-panel__body">
            <div className="ai-template-detail__header">
              <div className="ai-action-scratch-sidebar__icon">
                <KuikaSvg type="datasource-icons" name="ai-agent" width={48} height={48} color="var(--blue-5)" />
              </div>
              <div className="ai-template-detail__header-info">
                <div className="ai-template-detail__description-wrapper">
                  <p className="ai-template-detail__description">
                    Start with a blank multi-agent workflow and define every role, task, and tool to match your exact
                    orchestration needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="ai-template-detail__content">
              <div className="ai-action-scratch-sidebar__features">
                {this.scratchFeatures.map((feature) => (
                  <div className="ai-action-scratch-sidebar__feature" key={feature}>
                    <KuikaSvg type="common" name="check" width={16} height={16} color="var(--dark-5)" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="ai-template-detail-panel__footer">
            <KuikaButton
              type="primary"
              onClick={() => {
                this.openProcessTypeSelectionModal();
              }}
            >
              Start Building
            </KuikaButton>
          </div>
        </div>
      </div>
    );
  };

  renderProcessTypeSelectionModal = () => {
    const { showProcessTypeSelectionModal, pendingCustomProcessType } = this.state;

    return (
      <KModal
        className="ai-agent-type-modal"
        showModal={showProcessTypeSelectionModal}
        closeModal={this.closeProcessTypeSelectionModal}
        centered
        width={500}
        footer={
          <KModalFooter
            onCancel={this.closeProcessTypeSelectionModal}
            submitLabel="Create agent"
            onSubmit={() => void this.confirmCustomProcessTypeSelection()}
            disabled={!pendingCustomProcessType}
          />
        }
      >
        <div className="ai-agent-type-modal__title">CHOOSE AGENT TYPE</div>
        <div className="ai-agent-type-modal__subtitle">
          Agent type is permanent and cannot be changed after creation.
        </div>
        <div className="ai-agent-type-modal__options">
          <button
            type="button"
            className={`ai-agent-type-modal__option ${"ai-agent-type-modal__option--hierarchical"}${
              pendingCustomProcessType === "hierarchical" ? "-active" : ""
            }`}
            onClick={() => this.setPendingCustomProcessType("hierarchical")}
          >
            <div className="ai-agent-type-modal__option-header">
              <div className="ai-agent-type-modal__option-meta">
                <div className="ai-agent-type-modal__option-icon--hierarchical">
                  <KuikaSvg
                    type="datasource-icons"
                    name="hierarchical"
                    width={14}
                    height={14}
                    color="var(--orange-8)"
                  />
                </div>
                <span className="ai-agent-type-modal__chip ai-agent-type-modal__chip--hierarchical">Manager-based</span>
              </div>
              <div
                className={`ai-agent-type-modal__selection-indicator ${
                  pendingCustomProcessType === "hierarchical" ? "ai-agent-type-modal__selection-indicator--active" : ""
                }`}
              >
                <KuikaSvg type="common" name="check" width={20} height={20} color="var(--green-7)" />
              </div>
            </div>
            <div className="ai-agent-type-modal__option-title">Hierarchical</div>
            <div className="ai-agent-type-modal__option-description">
              Manager agent coordinates specialists, delegates tasks, and validates the final output quality.
            </div>
            {/* <div className="ai-agent-type-modal__option-footer">
              <span
                className={`ai-agent-type-modal__radio ${
                  pendingCustomProcessType === "hierarchical"
                    ? "ai-agent-type-modal__radio--active"
                    : ""
                }`}
              />
            </div> */}
          </button>

          <button
            type="button"
            className={`ai-agent-type-modal__option ${"ai-agent-type-modal__option--sequential"}${
              pendingCustomProcessType === "sequential" ? "-active" : ""
            }`}
            onClick={() => this.setPendingCustomProcessType("sequential")}
          >
            <div className="ai-agent-type-modal__option-header">
              <div className="ai-agent-type-modal__option-meta">
                <div className="ai-agent-type-modal__option-icon--sequential">
                  <KuikaSvg type="datasource-icons" name="sequential" width={14} height={14} color="var(--blue-8)" />
                </div>
                <span className="ai-agent-type-modal__chip ai-agent-type-modal__chip--sequential">Step-by-step</span>
              </div>
              <div
                className={`ai-agent-type-modal__selection-indicator ${
                  pendingCustomProcessType === "sequential" ? "ai-agent-type-modal__selection-indicator--active" : ""
                }`}
              >
                <KuikaSvg type="common" name="check" width={20} height={20} color="var(--green-7)" />
              </div>
            </div>
            <div className="ai-agent-type-modal__option-title">Sequential</div>
            <div className="ai-agent-type-modal__option-description">
              Agents execute step-by-step in order, passing work downstream from one specialist to the next.
            </div>
            {/* <div className="ai-agent-type-modal__option-footer">
              <span
                className={`ai-agent-type-modal__radio ${
                  pendingCustomProcessType === "sequential"
                    ? "ai-agent-type-modal__radio--active"
                    : ""
                }`}
              />
            </div> */}
          </button>
        </div>
      </KModal>
    );
  };

  getFilteredAgentTemplates = (): IAiAgentTemplate[] => {
    let filtered = this.state.agentTemplates;

    // Filter by selected frameworks
    if (this.state.selectedFrameworkIds?.length) {
      filtered = filtered.filter((template) => this.state.selectedFrameworkIds.includes(template.modelId));
    }

    // Filter by selected tags
    if (this.state.selectedTags?.length) {
      filtered = filtered.filter((template) => {
        const tags: string[] = (template as any).tags || [];
        return this.state.selectedTags.some((tag) => tags.includes(tag));
      });
    }

    // Filter by search term (case-insensitive search in name and description)
    // Normalize by removing spaces to match CamelCase names (e.g., "Cv Reader" matches "CvReader")
    if (this.state.searchTerm) {
      const searchNormalized = this.state.searchTerm.toLowerCase().replace(/\s+/g, "");
      filtered = filtered.filter(
        (template) =>
          template.name.toLowerCase().replace(/\s+/g, "").includes(searchNormalized) ||
          template.description.toLowerCase().includes(this.state.searchTerm.toLowerCase())
      );
    }

    return filtered;
  };

  setTemplateSelected = (modelId: string, name: string) => {
    const dontChangeName: boolean =
      (this.state.selectedTemplateId === undefined || this.state.selectedTemplateId === "custom") &&
      modelId === "custom";

    this.setState({ selectedTemplateId: modelId }, () => {
      if (dontChangeName) return;
      const nextName = modelId !== "custom" ? this.generateUniqueTemplateActionName(name) : name;

      this.setState({ actionName: nextName, isNameOnEdit: false }, () => {
        this.formRef.current?.setFieldsValue({
          name: nextName
        });
      });
    });
  };

  private generateUniqueTemplateActionName = (baseName: string): string => {
    const normalizedBaseName = (baseName || "").trim();
    if (!normalizedBaseName) return baseName;

    const existingNames = new Set(
      (this.props.sd.actionDefinitions || [])
        .map((action) => (action.name || "").trim().toLowerCase())
        .filter((name) => !!name)
    );

    let index = 0;
    let candidate = normalizedBaseName;
    while (existingNames.has(candidate.toLowerCase())) {
      index += 1;
      candidate = `${normalizedBaseName}${index}`;
    }

    return candidate;
  };

  createFromTemplate = async (modelId: string, name: string, template: any) => {
    this.setState({ isCreatingFromTemplate: true });

    const finalName = this.generateUniqueTemplateActionName(name);

    try {
      const aiAgentDatasourceId = await this.ensureAiAgentDatasourceId();

      const res = await DatasourceService.SaveAiAgentTemplate({
        datasourceId: aiAgentDatasourceId,
        aiTemplateId: modelId,
        actionName: finalName
      });

      if (res.status === 200) {
        await this.props.sd.loadActionDefinitions();

        const addedAction = this.props.sd.actionDefinitions?.find((x) => x.name === finalName);

        if (this.props.sd?.creatingDatasouceFolderId && addedAction?.id) {
          const folder = this.props.sd.getFolderById(
            this.props.sd?.creatingDatasouceFolderId,
            this.props.sd.project.actionFolders
          );
          if (folder && folder.parentFolderId) {
            this.props.sd.addActionToFolderInFolder(
              folder.parentFolderId,
              this.props.sd?.creatingDatasouceFolderId,
              addedAction?.id
            );
          } else {
            this.props.sd.addActionToFolder(this.props.sd?.creatingDatasouceFolderId, addedAction?.id);
          }
        }

        // A template card has no button to hold a ✓: the list the editor closes onto lights the
        // new agent's row up instead of a toast.
        requestDatasourceReveal({ name: finalName, parentId: aiAgentDatasourceId });
        this.closeDataSource();
        this.props.setShowModal(false);
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isCreatingFromTemplate: false });
    }
  };

  getUnconfiguredTools = (): { agentName: string; toolName: string }[] => {
    const unconfigured: { agentName: string; toolName: string }[] = [];
    for (const node of this.state.nodes) {
      const agent = node.data.metadata;
      if (!agent?.tools?.length) continue;
      for (const tool of agent.tools) {
        const toolDef = AGENT_TOOLS.find((t) => t.name === tool.name);
        const requiresSettings = !!toolDef?.mcpConfigName;
        if (requiresSettings && !tool.settingsId) {
          unconfigured.push({ agentName: agent.name, toolName: toolDef?.displayName || tool.name });
        }
      }
    }
    return unconfigured;
  };

  /** Templates and Recents are two views of the same page; the new one slides in (see render). */
  renderAgentTabPane = (tab: string): React.ReactNode =>
    tab === "templates" ? (
      <div
        className={`ai-action-templates-tab ${
          this.state.selectedFrameworkIds.length > 0 || this.state.selectedTags.length > 0 || this.state.searchTerm
            ? "ai-action-templates-tab--with-filters"
            : "ai-action-templates-tab--without-filters"
        }`}
      >
        {this.getFilteredAgentTemplates().length === 0 &&
        !this.state.isTemplatesLoading &&
        !this.state.isCreatingFromTemplate ? (
          <div className="ai-action-templates-empty">
            <div className="ai-action-templates-empty__icon-container">
              <KuikaSvg type="common" name="search" width={40} height={40} color="var(--dark-3)" />
            </div>
            <h4>No templates found</h4>
            <p>Try adjusting your search or filters</p>
          </div>
        ) : (
          <AIActionTemplates
            aiTemplates={this.getFilteredAgentTemplates()}
            aiModels={this.state.agentModels}
            selectedTemplateId={this.state.selectedTemplateId}
            setTemplateSelected={this.setTemplateSelected}
            isTemplatesLoading={this.state.isTemplatesLoading || this.state.isCreatingFromTemplate}
            isEditing={false}
            onCreateTemplate={this.createFromTemplate}
          />
        )}
      </div>
    ) : (
      this.renderAgentRecentsTable()
    );

  renderUpdateButton = () => {
    // UPDATE on an agent that already exists, SAVE while creating one — the wording every
    // other tool's editor uses.
    const commitLabel: string = this.props.actionToEdit ? "UPDATE" : "SAVE";
    const buttonText = this.state.isFixingAgents ? "Fixing agents" : commitLabel;
    const isFixingAgents = this.state.isFixingAgents;
    const unconfiguredTools = this.getUnconfiguredTools();
    const hasUnconfiguredTools = unconfiguredTools.length > 0;
    const updateDisabled = this.state.submitButtonDisabledStatus || hasUnconfiguredTools;

    const autoFixMenuItem = (
      <div
        className="ai-action__split-save-autofix-menu-item"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <KuikaSwitch
          label="Auto-fix"
          labelPosition="left"
          checked={this.state.autoFixEnabled}
          defaultChecked={false}
          onChange={(checked) => this.setState({ autoFixEnabled: checked })}
        />
        <KuikaTooltip
          content="Auto-fixing sends your agent configuration to an LLM that reviews and applies corrections before saving"
          position="left"
        >
          <span className="ai-action__split-save-autofix-info">
            <KuikaSvg type="common" name="info-circle" width={14} height={14} color="var(--dark-6)" />
          </span>
        </KuikaTooltip>
      </div>
    );

    // "Fixing agents" is its own busy state with its own words and no alternatives to offer, so it
    // is a single button; the save's status takes over on the split once the fixed agents are
    // being written.
    const updateButton = isFixingAgents ? (
      <KuikaButton type="primary" loading disabled={updateDisabled} className="ai-action__split-save-main--single">
        {buttonText}
      </KuikaButton>
    ) : (
      <KuikaSplitButton
        onClick={this.handlePublishClick}
        status={this.state.saveStatus}
        disabled={updateDisabled}
        menuLabel="More save actions"
        aria-label="Save actions"
        options={[
          {
            key: "save-draft",
            label: "Save as Draft",
            disabled: hasUnconfiguredTools,
            onClick: () => {
              if (hasUnconfiguredTools) return;
              this.handleSaveDraftClick();
            }
          }
        ]}
        menuFooter={autoFixMenuItem}
      >
        {buttonText}
      </KuikaSplitButton>
    );

    return (
      <div
        className={classNames("ai-action__split-save", {
          "ai-action__split-save--single": isFixingAgents
        })}
      >
        {hasUnconfiguredTools && !isFixingAgents ? (
          <KuikaTooltip
            content={
              <div className="ai-action__split-save-tooltip">
                <div className="ai-action__split-save-tooltip-title">Configure these tools before saving:</div>
                <ul className="ai-action__split-save-tooltip-list">
                  {unconfiguredTools.map((t, idx) => (
                    <li key={`${t.agentName}-${t.toolName}-${idx}`}>
                      <strong>{t.toolName}</strong> on agent &ldquo;{t.agentName}&rdquo;
                    </li>
                  ))}
                </ul>
              </div>
            }
            position="top"
          >
            <span className="ai-action__split-save-disabled-wrapper">{updateButton}</span>
          </KuikaTooltip>
        ) : (
          updateButton
        )}
      </div>
    );
  };

  renderSubmitButton = (label, onClick) => (
    <KuikaButton type="primary" disabled={this.state.submitButtonDisabledStatus} onClick={onClick}>
      {label}
    </KuikaButton>
  );

  renderButtons = () => {
    const { actionToEdit } = this.props;
    const { isCreatingCustomTemplate, selectedTemplateId } = this.state;

    if (actionToEdit) {
      if (isCreatingCustomTemplate) {
        return this.renderUpdateButton();
      }
      return this.renderSubmitButton("UPDATE", () => this.saveAiTemplate(actionToEdit.id));
    }
    if (selectedTemplateId !== "custom" && !isCreatingCustomTemplate) {
      return this.renderSubmitButton("NEXT", () => this.handleTemplateNext());
    }
    if (selectedTemplateId === "custom" && !isCreatingCustomTemplate) {
      return this.renderSubmitButton("NEXT", (e) => {
        e.preventDefault();
        this.setState({ isCreatingCustomTemplate: true });
      });
    }
    if (isCreatingCustomTemplate) {
      return this.renderUpdateButton();
    }

    return null;
  };

  setSubmitButtonDisabledStatus() {
    if (!this.state.selectedTemplateId && !this.state.isCreatingCustomTemplate) {
      this.setState({ submitButtonDisabledStatus: true });
      return;
    }
    if (this.state.selectedTemplateId === "custom" && this.state.isCreatingCustomTemplate) {
      if (!this.formRef.current) {
        this.setState({ submitButtonDisabledStatus: true });
        return;
      }
    }

    if (this.objectHash === this.getObjectHash()) {
      this.setState({ submitButtonDisabledStatus: true });
      return;
    }
    this.setState({ submitButtonDisabledStatus: false });
  }

  saveAiTemplate = async (actionId?: string) => {
    try {
      const aiAgentDatasourceId = await this.ensureAiAgentDatasourceId();
      const res = await DatasourceService.SaveAiAgentTemplate({
        datasourceId: aiAgentDatasourceId,
        aiTemplateId: this.state.selectedTemplateId ?? "",
        actionId: actionId ?? undefined,
        actionName: this.formRef.current?.getFieldValue("name")
      });
      if (res.status !== 200) return;

      KMainFunctions.displaySuccessNotification("AI Template successfully saved.");

      await this.props.sd.loadActionDefinitions();

      const addedAction = this.props.sd.actionDefinitions?.find(
        (x) => x.name === this.formRef.current?.getFieldValue("name")
      );

      if (this.props.sd?.creatingDatasouceFolderId && addedAction?.id) {
        const folder = this.props.sd.getFolderById(
          this.props.sd?.creatingDatasouceFolderId,
          this.props.sd.project.actionFolders
        );
        if (folder && folder.parentFolderId) {
          this.props.sd.addActionToFolderInFolder(
            folder.parentFolderId,
            this.props.sd?.creatingDatasouceFolderId,
            addedAction?.id
          );
        } else {
          this.props.sd.addActionToFolder(this.props.sd?.creatingDatasouceFolderId, addedAction?.id);
        }
      }

      this.closeDataSource();
      this.props.setShowModal(false);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  };

  createCommonConfig = ({
    formInputName,
    customizedId,
    configKey,
    config,
    onSuccess,
    onError = () => {},
    onFinal
  }: ICommonConfigSaveFunctionParams) => {
    this.setState({ isSaveDisabled: true });
    ConfigService.createCommonConfig(this.props.sd.project.id, configKey, config)
      .then(() => {
        onSuccess();
        this.props.sd.fetchConfigs({
          shouldLockPage: true,
          shouldFetchGlobals: true,
          callback: () => {
            const nodes = _.cloneDeep(this.state.nodes);
            const toolNode = nodes.find((node) => node.id === this.state.mcpModalIndexes?.nodeId);
            const tool = toolNode?.data.metadata.tools?.find((_tool, i) => i === this.state.mcpModalIndexes?.toolIndex);
            if (!toolNode || !tool) return;
            tool.settingsId = config.id;
            this.setState((prev) => ({
              nodes: this.withSelection(nodes, prev.selectedAgentId),
              isSaveDisabled: false
            }));
            // const parameter = _.cloneDeep(this.props.action.parameters.find((x) => x.name === "settings"));
            // if (!parameter) return;
            // this.updateActionParameter(parameter, {
            //   isFixed: true,
            //   fixedValue: config.id,
            //   category: ESymbolCategory.fixed
            // } as ISymbol);
          }
        });
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  updateCommonConfig = ({
    formInputName,
    customizedId,
    configKey,
    config,
    onSuccess,
    onError = () => {},
    onFinal
  }: ICommonConfigSaveFunctionParams) => {
    ConfigService.updateCommonConfig(this.props.sd.project.id, configKey, config)
      .then(() => {
        onSuccess();
        this.setState({ isSaveDisabled: true });
        this.props.sd.fetchConfigs({
          shouldLockPage: true,
          shouldFetchGlobals: true,
          callback: () => {
            this.setState({ isSaveDisabled: false });
            // const parameter = _.cloneDeep(this.props.action.parameters.find((x) => x.name === "settings"));
            // if (!parameter) return;
            // this.updateActionParameter(parameter, {
            //   isFixed: true,
            //   fixedValue: "",
            //   category: ESymbolCategory.fixed
            // } as ISymbol);
          }
        });
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  deleteCommonConfig = ({
    formInputName,
    configKey,
    configId,
    onSuccess,
    onError = () => {},
    shouldControlOtherSections,
    onFinal
  }: ICommonConfigDeleteFunctionParams) => {
    const activeConfigID = this.props.sd.activeConfiguration?.id;

    const isSettingUsedOnElswhere = this.props.sd.configurations.find(
      (config) =>
        config.id !== activeConfigID &&
        ((config.androidConfig && config.androidConfig[formInputName[1]] === configId) ||
          (config.iosConfig && config.iosConfig[formInputName[1]] === configId) ||
          (config.webConfig && config.webConfig[formInputName[1]] === configId))
    );

    if (isSettingUsedOnElswhere) {
      KMainFunctions.displayWarningNotification(
        "This setting is used on another configuration(s). Please discard this setting on other configurations before delete."
      );
      onFinal();
      return;
    }

    if (shouldControlOtherSections) {
      // if (this.isCommonConfigUsedOnOtherSections(formInputName, shouldControlOtherSections.listOfControl)) {
      shouldControlOtherSections.onCannotDelete();
      onFinal();
      return;
      // }
    }

    ConfigService.deleteCommonConfig(this.props.sd.project.id, configKey, configId)
      .then(() => {
        onSuccess();
        this.setState({ isSaveDisabled: true });
        this.props.sd.fetchConfigs({
          shouldLockPage: true,
          shouldFetchGlobals: true,
          callback: () => {
            const nodes = _.cloneDeep(this.state.nodes);
            const toolNode = nodes.find((node) => node.id === this.state.mcpModalIndexes?.nodeId);
            const tool = toolNode?.data.metadata.tools?.find((_tool, i) => i === this.state.mcpModalIndexes?.toolIndex);
            if (!toolNode || !tool) return;
            tool.settingsId = undefined;
            this.setState((prev) => ({
              nodes: this.withSelection(nodes, prev.selectedAgentId),
              isSaveDisabled: false
            }));
            // this.handleUpdateCustomFormInput(formInputName, null);
          }
        });
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  updateMcpModalVisibility = (key: string, visibility: boolean, id?: string) => {
    const mcpConfigModalVisibility = _.cloneDeep(this.state.mcpConfigModalVisibility);
    if (!mcpConfigModalVisibility[key]) {
      mcpConfigModalVisibility[key] = {};
    }
    mcpConfigModalVisibility[key].editingId = id;
    mcpConfigModalVisibility[key].visibility = visibility;
    this.setState({ mcpConfigModalVisibility });
  };

  handleCheckAgents = () => {
    // Build current agent state summary for the AI to analyze
    const agentNames = this.state.nodes.map((node) => node.data.metadata.name).join(", ");
    const agentCount = this.state.nodes.length;
    const inputCount = this.state.crew_inputs?.length || 0;
    const customTypeCount = this.state.crew_custom_data_types?.length || 0;
    const edgeCount = this.state.edges.length;

    // Create a detailed summary of the current configuration
    const configSummary = `
Current Agent Configuration Summary:
- Total Agents: ${agentCount} (${agentNames || "none"})
- Total Inputs: ${inputCount}
- Total Custom Data Types: ${customTypeCount}
- Total Connections: ${edgeCount}

Agent Details:
${this.state.nodes
  .map((node) => {
    const agent = node.data.metadata;
    const tools = agent.tools?.map((t) => t.name).join(", ") || "none";
    const outputFormat = agent.task?.output_format ? Object.keys(agent.task.output_format).join(", ") : "not defined";
    return `- ${agent.name}: 
  Role: ${agent.role}
  Tools: ${tools}
  Output Format: ${outputFormat}
  Model: ${typeof agent.model === "string" ? agent.model : (agent.model as { id?: string; name?: string } | undefined)?.id || (agent.model as { id?: string; name?: string } | undefined)?.name || "not set"}`;
  })
  .join("\n")}

Inputs: ${
      this.state.crew_inputs?.map((input) => `${input.parameter_name} (${input.parameter_format})`).join(", ") || "none"
    }

Custom Data Types: ${this.state.crew_custom_data_types?.map((type) => type.type_name).join(", ") || "none"}
`;

    const prompt = `${configSummary}

Please analyze the agent configuration above. Check if:
1. All agents are properly configured with the right tools
2. Each agent has a proper Response object (output_format) defined
3. AI Agent inputs are correctly referenced in task descriptions
4. All agents connect together logically and the data flow is correct
5. Tools are appropriate for each agent's task
6. Custom data types are used correctly
7. HIERARCHICAL-MODE RULES (check only if processType is hierarchical):
   - The manager agent MUST own the task description, expected_output, and output_format. Flag as [FIX] if missing.
   - Sub-agents (everything in crewAgents) MUST NOT have their own task descriptions, expected_output, or output_format. Flag any sub-agent with these as [FIX].
   - Sub-agents must NOT have a memoryMode. Memory is manager-only in hierarchical mode. Flag any sub-agent memoryMode as [FIX].
   - Sub-agents only carry capability fields (role, goal, backstory, tools, model). Anything else is [REMOVE].

If you find any issues, return ONE finding per line. STRICT FORMAT — every line must:
1. Start with EXACTLY one category tag in square brackets at the BEGINNING of the line
2. Be followed by a single space, then the finding text
3. End with a newline (use real \\n line breaks, not commas or other separators)

Allowed category tags (use ONLY these, uppercase, no variants):
[FIX]     - bugs or misconfigurations that will break the workflow
[ADD]     - missing pieces that should be added
[REMOVE]  - unused or redundant pieces that should be removed
[IMPROVE] - non-critical improvements or refinements
[INFO]    - informational notes or observations

Required format example (note newlines between every finding):
[FIX] Agent "Researcher" is missing an output_format on its task.
[ADD] Add a "topic" input parameter referenced by the Researcher's task description.
[IMPROVE] Consider adding ScrapeWebsiteTool to the Researcher agent for richer data.

Hard rules:
- DO NOT put the tag at the end of a line.
- DO NOT put multiple findings on the same line.
- DO NOT add bullets, dashes, numbers, headings, or any markdown.
- DO NOT add any commentary, intro, or closing text.
- If there are no issues, return the single line: [INFO] Configuration looks good.`;

    this.setState({ isFixingAgents: true });
    this.onMessageSend(prompt);
  };

  existingNameValidator = (_: any, value: string) => {
    const { actionToEdit } = this.props;
    const existingAction = this.props.sd.actionDefinitions.find(
      (action) => action.name === value && action.id !== actionToEdit?.id
    );

    if (existingAction) {
      return Promise.reject(new Error("An AI Agent with this name already exists"));
    }

    return Promise.resolve();
  };

  /**
   * How the crew runs, in the glyph's tooltip ("AI Agent · Hierarchical"): a fact about the agent,
   * not a control, so it no longer takes a badge's room on the bar. The body's banner still
   * explains what the mode does.
   */
  getProcessTypeLabel = (): string | undefined => {
    if (this.state.processType === "hierarchical") return "Hierarchical";
    if (this.state.processType === "sequential") return "Sequential";
    return undefined;
  };

  render(): ReactNode {
    this.setSubmitButtonDisabledStatus();

    const mcpToolNode = this.state.nodes.find((node) => node.id === this.state.mcpModalIndexes?.nodeId);
    const mcpTool = mcpToolNode?.data.metadata.tools?.find((_tool, i) => i === this.state.mcpModalIndexes?.toolIndex);
    const mcpToolDefinition = AGENT_TOOLS.find((tool) => tool.name === mcpTool?.name);
    const { nodes: flowNodes, edges: flowEdges } = buildAIAgentFlowWithProcessType(
      this.state.nodes,
      this.state.edges,
      this.state.processType,
      this.state.managerAgent
    );

    const flowNodesWithActions = flowNodes.map((node) => {
      if (node.type !== "manager") {
        return node;
      }

      return {
        ...node,
        data: {
          ...(node.data as IAiAgentManagerNodeData),
          onAddAgent: this.state.viewMode === "preview" ? undefined : () => this.handleAddAgent(true)
        }
      };
    });

    return (
      <>
        <Form
          name="dsModal"
          ref={this.formRef}
          onFinish={() => this.saveAction(EAiActionStatus.Published)}
          onValuesChange={() => {
            this.setSubmitButtonDisabledStatus();
          }}
          layout="vertical"
          style={{ height: "100%" }}
        >
          <KuikaSpinnerSmall spinning={this.state.isSaveDisabled}>
            <div className="kuika__data-diagram__create-con kuika__data-diagram__create-con--bar kuika-ai-agent">
              {!this.shouldShowTemplateSelection() && (
                <KuikaPageHeader
                  variant="bar"
                  title={this.state.actionName ?? ""}
                  onBack={() => this.handleCloseDatasource()}
                  backLabel="Back to AI Functions"
                  renderTitle={(): React.ReactNode => (
                    <KuikaEditorTitle
                      entityLabel="AI agent"
                      isRenaming={this.state.isNameOnEdit}
                      canAbortRename={!!this.state.actionName}
                      onStartRename={() => this.setState({ isNameOnEdit: true })}
                      onConfirmRename={this.handleSubmitNameChange}
                      onAbortRename={this.handleAbortNameChange}
                      editTestId="aiAgentNameEditButton"
                      confirmTestId="aiAgentNameConfirmButton"
                      abortTestId="aiAgentNameCancelButton"
                      identity={
                        <AiActionSwitcherChip
                          sd={this.props.sd}
                          setNextCallbackFunction={this.props.setNextCallbackFunction}
                          actionType={EDatasourceType.AIAgent}
                          currentActionId={this.props.actionToEdit?.id}
                          currentName={this.state.actionName ?? ""}
                          glyphDetail={this.getProcessTypeLabel()}
                          triggerTestId="aiAgentSwitcherTrigger"
                          onManageAll={() => this.handleCloseDatasource()}
                        />
                      }
                      renameField={
                        <Form.Item
                          name={"name"}
                          rules={[
                            { required: true, message: "Please enter a AI Agent name" },
                            { validator: this.existingNameValidator }
                          ]}
                        >
                          <KuikaInput onKeyDown={this.handleNameInputOnEnter} placeholder="AI Agent Name" />
                        </Form.Item>
                      }
                    />
                  )}
                  center={
                    <div className="ai-agent-view-tabs">
                      <KuikaTabs
                        options={[
                          {
                            value: "preview",
                            label: (
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px"
                                }}
                              >
                                <KuikaSvg type="datasource-icons" name="eye" width={14} height={14} />
                                View
                              </span>
                            )
                          },
                          {
                            value: "edit",
                            label: (
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px"
                                }}
                              >
                                <KuikaSvg type="common" name="edit" width={14} height={14} />
                                Edit
                              </span>
                            )
                          }
                        ]}
                        value={this.state.viewMode}
                        onChange={(value) => this.setState({ viewMode: value as ViewMode })}
                      />
                    </div>
                  }
                  actions={
                    /* The walkthrough finds this cluster by the attribute, so it stays. */
                    <span className="kuika-ai-agent__bar-actions" data-ai-agent-walkthrough="actions">
                      {/** Undo/redo belong to edit mode; view mode keeps their space. */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginRight: "auto",
                          visibility: this.state.viewMode === "edit" ? "visible" : "hidden"
                        }}
                      >
                        <KuikaTooltip content="Undo" position="top">
                          <KuikaButton
                            type="tertiary"
                            size="sm"
                            isIcon
                            onClick={this.handleUndo}
                            disabled={!this.canUndo()}
                          >
                            <KuikaSvg type="arrows" name="arrow-back-up" width={14} height={14} />
                          </KuikaButton>
                        </KuikaTooltip>
                        <KuikaTooltip content="Redo" position="top">
                          <KuikaButton
                            type="tertiary"
                            size="sm"
                            isIcon
                            onClick={this.handleRedo}
                            disabled={!this.canRedo()}
                          >
                            <KuikaSvg type="arrows" name="arrow-forward-up" width={14} height={14} />
                          </KuikaButton>
                        </KuikaTooltip>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          visibility: this.state.viewMode === "edit" ? "visible" : "hidden"
                        }}
                      >
                        {this.state.isCreatingCustomTemplate && (
                          <KuikaButton
                            type="secondary"
                            onClick={() => {
                              this.handleOpenTestModal();
                            }}
                            style={{ marginRight: "8px" }}
                          >
                            TEST
                          </KuikaButton>
                        )}
                        {this.renderButtons()}
                      </div>
                    </span>
                  }
                />
              )}
              <div className="kuika__data-diagram__create-con__container-ai-templates">
                {this.shouldShowTemplateSelection() ? (
                  <div className="ai-action-selector">
                    <KuikaListPageHeader
                      onBack={() => this.handleCloseDatasource()}
                      backLabel="Back to AI Functions"
                      icon={
                        <KuikaSvg
                          color="var(--blue-5)"
                          type="datasource-icons"
                          name="ai-agent"
                          width={20}
                          height={20}
                        />
                      }
                      title="Add AI Agent"
                    />

                    {this.state.isScratchEmptyStateVisible ? (
                      <CreateScratchEmptyState
                        theme="blue"
                        iconName="ai-agent"
                        title="Create an AI Agent"
                        description="Start with a blank multi-agent workflow and define every role, task, and tool to match your exact orchestration needs."
                        learnMoreLink="https://academy.kuika.com/en/content/ai-agent"
                        features={this.scratchFeatures}
                        onBack={this.closeScratchEmptyState}
                        onStart={() => {
                          this.openProcessTypeSelectionModal();
                        }}
                      />
                    ) : (
                      <>
                        {this.renderCreateFromScratch()}

                        <KuikaListPageToolbar
                          tabs={
                            <KuikaTabs
                              size="lg"
                              options={[
                                { value: "templates", label: "Templates" },
                                { value: "recents", label: "Recents" }
                              ]}
                              value={this.state.activeTab}
                              onChange={(value) =>
                                this.setState({
                                  activeTab: value as "templates" | "recents"
                                })
                              }
                            />
                          }
                          search={
                            <KuikaInput
                              size="md"
                              placeholder="Search..."
                              value={this.state.searchTerm}
                              leftIcon={<KuikaSvg name="search" width={14} height={14} />}
                              onChange={(e, value) => this.handleSearchTemplates(value as string)}
                            />
                          }
                          filters={
                            this.state.activeTab === "templates" &&
                            (this.state.selectedFrameworkIds.length > 0 ||
                              this.state.selectedTags.length > 0 ||
                              this.state.searchTerm) ? (
                              <KuikaTooltip content="Clear all filters" position="top">
                                {/* The tooltip refs its trigger and KuikaButton has no
                                    forwardRef, so it anchors to a real element. */}
                                <span className="ai-action-clear-filters">
                                  <KuikaButton
                                    type="tertiary"
                                    size="sm"
                                    isIcon
                                    onClick={() =>
                                      this.setState({
                                        selectedFrameworkIds: [],
                                        selectedTags: [],
                                        searchTerm: ""
                                      })
                                    }
                                  >
                                    <KuikaSvg name="circle-x" width={16} height={16} />
                                  </KuikaButton>
                                </span>
                              </KuikaTooltip>
                            ) : undefined
                          }
                        />
                        {/* Templates and Recents: the new view slides in from the side the selection
                            moved towards instead of cutting. */}
                        <KuikaTabContent
                          className="ai-action-panel__tab-content"
                          activeKey={this.state.activeTab}
                          order={AI_AGENT_TAB_ORDER}
                          render={this.renderAgentTabPane}
                        />
                      </>
                    )}
                    {this.renderScratchSidebar()}
                  </div>
                ) : (
                  <div className="kuika__data-diagram__create-con__body kuika-ai-agent__body kuika-ai-agent__body--with-sidebar">
                    <div className="kuika-ai-agent__workflow-area" data-ai-agent-walkthrough="canvas">
                      {this.renderAIAgentFloatingPalette()}
                      <ReactFlow
                        className="kuika-ai-agent__react-flow"
                        nodes={flowNodesWithActions}
                        edges={flowEdges}
                        onDragOver={this.handleCanvasDragOver}
                        onDrop={(event) => {
                          void this.handleCanvasDrop(event);
                        }}
                        onInit={(instance) => {
                          this.reactFlowInstance = instance;
                        }}
                        onNodesChange={(changes: NodeChange[]) => {
                          if (this.state.showProcessTypeWalkthrough) {
                            return;
                          }

                          const crewNodeIds = new Set(this.state.nodes.map((node) => node.id));
                          const filteredChanges = changes.filter(
                            (change) => change.type !== "select" && "id" in change && crewNodeIds.has(change.id)
                          );
                          if (!filteredChanges.length) {
                            return;
                          }
                          this.setState((prev) => ({
                            nodes: this.withSelection(
                              applyNodeChanges(filteredChanges, prev.nodes) as IElkNode[],
                              prev.selectedAgentId
                            )
                          }));
                        }}
                        // onEdgesChange={this.onEdgesChange}
                        minZoom={0.2}
                        maxZoom={4}
                        attributionPosition="bottom-left"
                        fitView
                        fitViewOptions={{ padding: 0.3 }}
                        zoomOnScroll={false}
                        panOnDrag={!this.state.showProcessTypeWalkthrough && this.state.isCanvasPanEnabled}
                        panOnScroll={false}
                        onMoveStart={() => {
                          window.dispatchEvent(new CustomEvent("agent-dropdown-close-all"));
                        }}
                        onNodeClick={(event, node) => {
                          if (this.state.showProcessTypeWalkthrough) {
                            return;
                          }

                          event.preventDefault();
                          if (node.type === "manager") {
                            this.setState((prev) => ({
                              isManagerSelected: true,
                              selectedAgentId: undefined,
                              rightPanelTab: "params",
                              walkthroughPreferredAccordionKey:
                                prev.walkthroughPreferredAccordionKey === "managerInfo" ? "managerInfo_" : "managerInfo"
                            }));
                            return;
                          }
                          this.setState({ isManagerSelected: false });
                          this.selectNode(node.id);
                        }}
                        onPaneClick={() => {
                          if (this.state.showProcessTypeWalkthrough) {
                            return;
                          }

                          this.setState({ isManagerSelected: false });
                          this.clearSelectedNode();
                        }}
                        onConnect={(connection) => {
                          if (this.state.showProcessTypeWalkthrough || this.state.processType === "hierarchical") {
                            return;
                          }

                          this.setState((prev) => {
                            const edgeId = `${connection.source}-${connection.target}`;
                            if (prev.edges.some((edge) => edge.id === edgeId)) {
                              return null;
                            }
                            const newEdge = {
                              id: edgeId,
                              source: connection.source!,
                              target: connection.target!,
                              sourceHandle: connection.sourceHandle,
                              targetHandle: connection.targetHandle,
                              type: "default"
                            };
                            return {
                              edges: [...prev.edges, newEdge],
                              hasManualChanges: true
                            };
                          });
                        }}
                        nodeTypes={this.reactFlowNodeTypes}
                        edgesUpdatable={false}
                        edgesFocusable={false}
                        nodesDraggable={!this.state.showProcessTypeWalkthrough && !this.state.isCanvasPanEnabled}
                        nodesConnectable={
                          this.state.viewMode !== "preview" &&
                          this.state.processType !== "hierarchical" &&
                          !this.state.showProcessTypeWalkthrough &&
                          !this.state.isCanvasPanEnabled
                        }
                        nodesFocusable={true}
                        // draggable={false}
                        // panOnDrag={false}
                      >
                        <Background />
                        {this.state.isMiniMapVisible && <MiniMap nodeStrokeWidth={3} zoomable pannable />}
                        <SharedReactFlowControls
                          showMiniMapToggle
                          isMiniMapVisible={this.state.isMiniMapVisible}
                          onToggleMiniMap={() =>
                            this.setState((prev) => ({
                              isMiniMapVisible: !prev.isMiniMapVisible
                            }))
                          }
                        />
                      </ReactFlow>
                      {this.renderProcessTypeWalkthrough()}
                    </div>
                    <div className="kuika-ai-agent__right-panel" data-ai-agent-walkthrough="sidebar">
                      <div className="kuika-ai-agent__right-panel-tabs">
                        <KuikaTabs
                          options={[
                            { value: "chat", label: "AI Chat" },
                            { value: "params", label: "Params" }
                          ]}
                          value={this.state.rightPanelTab}
                          onChange={(value) =>
                            this.setState({
                              rightPanelTab: value as RightPanelTab
                            })
                          }
                        />
                      </div>
                      <div className="kuika-ai-agent__right-panel-content">
                        {this.state.rightPanelTab === "chat" ? (
                          <KuikaChatBot
                            ref={this.chatbotRef}
                            messagesContainerRef={this.chatbotMessagesContainerRef}
                            initMessage="Hey there, type a prompt to generate your own agent."
                            messages={this.state.chatbotMessages}
                            isLoading={this.state.isSaveDisabled}
                            onMessageSend={this.onMessageSend}
                          />
                        ) : (
                          <AIAgentSidebar
                            inputs={this.state.crew_inputs}
                            agents={this.state.nodes.map((node) => node.data.metadata)}
                            customDataTypes={this.state.crew_custom_data_types}
                            processType={this.state.processType}
                            managerAgent={this.state.managerAgent}
                            processManagerReadOnly={this.isTemplateOriginAction()}
                            isManagerMode={this.state.isManagerSelected}
                            selectedAgent={
                              this.state.isManagerSelected
                                ? this.state.nodes.find(
                                    (node) => node.data.metadata?.name === this.state.managerAgent?.name
                                  )?.data.metadata
                                : this.state.nodes.find((node) => node.id === this.state.selectedAgentId)?.data.metadata
                            }
                            viewMode={this.state.viewMode}
                            onProcessTypeChange={this.handleProcessTypeChange}
                            onManagerAgentChange={this.handleManagerAgentChange}
                            crewMemoryOptions={this.state.crewMemoryOptions}
                            onCrewMemoryOptionsChange={this.handleCrewMemoryOptionsChange}
                            conversationHistoryEnabled={this.state.conversationHistoryEnabled}
                            onConversationHistoryChange={(enabled) => {
                              this.pushToHistory();
                              const updatedInputs = [...this.state.crew_inputs];
                              let updatedManager = this.state.managerAgent ? { ...this.state.managerAgent } : undefined;
                              if (enabled) {
                                if (!updatedInputs.some((i) => i.parameter_name === "session_id")) {
                                  updatedInputs.push({ parameter_name: "session_id", parameter_format: "str" });
                                }
                                if (!updatedInputs.some((i) => i.parameter_name === "user_message")) {
                                  updatedInputs.push({ parameter_name: "user_message", parameter_format: "str" });
                                }
                                if (updatedManager) {
                                  const task = updatedManager.task
                                    ? { ...updatedManager.task }
                                    : { description: "", expected_output: "", output_format: {} };
                                  const outputFormat = { ...task.output_format };
                                  if (!outputFormat.answer) {
                                    outputFormat.answer = "str (The final answer to the user message)";
                                  }
                                  task.output_format = outputFormat;
                                  updatedManager = { ...updatedManager, task };
                                }
                              }
                              this.setState({
                                conversationHistoryEnabled: enabled,
                                crew_inputs: updatedInputs,
                                managerAgent: updatedManager,
                                hasManualChanges: true
                              });
                            }}
                            onInputsChange={this.handleUpdateAIInputs}
                            onCustomDataTypesChange={this.handleUpdateCustomDataTypes}
                            onOpenInputsModal={this.handleOpenInputsModal}
                            onOpenCustomTypesModal={this.handleOpenCustomTypesModal}
                            onOpenManagerResponseModal={this.handleOpenManagerResponseModal}
                            onOpenResponseModal={() => {
                              const agentNodeId =
                                this.state.selectedAgentId ??
                                (this.state.isManagerSelected
                                  ? this.state.nodes.find(
                                      (n) => n.data.metadata?.name === this.state.managerAgent?.name
                                    )?.id
                                  : undefined);
                              if (agentNodeId) {
                                this.handleOpenResponseModal(agentNodeId);
                              }
                            }}
                            onOpenMcpConfig={(toolIndex) => {
                              const agentNodeId =
                                this.state.selectedAgentId ??
                                (this.state.isManagerSelected
                                  ? this.state.nodes.find(
                                      (n) => n.data.metadata?.name === this.state.managerAgent?.name
                                    )?.id
                                  : undefined);
                              if (agentNodeId) {
                                this.handleOpenMcpModal(agentNodeId, toolIndex);
                              }
                            }}
                            onClearSelection={() => {
                              this.setState({ isManagerSelected: false });
                              this.clearSelectedNode();
                            }}
                            onAgentUpdate={(agent) => {
                              const targetNodeId =
                                this.state.selectedAgentId ??
                                (this.state.isManagerSelected
                                  ? this.state.nodes.find(
                                      (n) => n.data.metadata?.name === this.state.managerAgent?.name
                                    )?.id
                                  : undefined);
                              if (targetNodeId) {
                                this.pushToHistory();
                                const nodes = _.cloneDeep(this.state.nodes);
                                const node = nodes.find((n) => n.id === targetNodeId);
                                if (node) {
                                  node.data.metadata = agent;
                                  this.setState({
                                    nodes: this.withSelection(nodes, this.state.selectedAgentId),
                                    hasManualChanges: true
                                  });
                                }
                              }
                            }}
                            onEditAgentName={() => {
                              // Edit functionality handled in sidebar via onAgentUpdate
                            }}
                            onRemoveAgent={() => {
                              if (this.state.selectedAgentId) {
                                this.removeNode(this.state.selectedAgentId);
                              }
                            }}
                            preferredAccordionKey={this.state.walkthroughPreferredAccordionKey}
                            commonSettings={this.props.sd.commonSettings}
                            activeMcpToolIndex={
                              this.state.mcpModalIndexes?.nodeId === this.state.selectedAgentId
                                ? this.state.mcpModalIndexes?.toolIndex
                                : null
                            }
                            onMcpSettingsSave={this.handleSidebarMcpSettingsSave}
                            onCloseMcpConfig={() => this.setState({ mcpModalIndexes: undefined })}
                            onOpenMcpAddConfig={(mcpTool) => {
                              if (mcpTool.mcpConfigName) {
                                this.updateMcpModalVisibility(mcpTool.mcpConfigName, true, mcpTool.settingsId);
                              }
                            }}
                            kActionOptions={this.getAvailableKActions().map((a) => actionToToolOption(a))}
                            activeKActionId={this.state.activeKActionId}
                            onCloseKActionDetail={() => this.setState({ activeKActionId: null })}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {this.renderProcessTypeSelectionModal()}
              </div>
            </div>
          </KuikaSpinnerSmall>
          <AiAgentResponseModal
            agent={this.state.nodes.find((node) => node.id === this.state.selectedAgentId)?.data.metadata}
            agentDefintions={this.state.crew_custom_data_types}
            isOpen={this.state.showResponseModal}
            onClose={this.handleCloseResponseModal}
            onAgentUpdate={this.handleUpdateAIAgent}
          />
          <AiAgentResponseModal
            agent={this.state.managerAgent as any}
            agentDefintions={this.state.crew_custom_data_types}
            isOpen={this.state.showManagerResponseModal}
            onClose={this.handleCloseManagerResponseModal}
            onAgentUpdate={(updatedAgent, updatedDefinitions) => {
              this.handleManagerAgentChange({
                ...this.state.managerAgent,
                task: updatedAgent.task
              });
              if (updatedDefinitions) {
                this.handleUpdateCustomDataTypes(updatedDefinitions);
              }
              // The dialog closes itself once its Update ✓ has been seen.
            }}
          />

          <AiAgentInputsModal
            inputs={this.state.crew_inputs}
            isOpen={this.state.showInputsModal}
            onClose={this.handleCloseInputsModal}
            onAgentInputsUpdate={this.handleUpdateAIInputs}
          />

          <AiAgentCustomDataTypesModal
            customDataTypes={this.state.crew_custom_data_types || []}
            isOpen={this.state.showCustomTypesModal}
            onClose={this.handleCloseCustomTypesModal}
            onCustomDataTypesUpdate={this.handleUpdateCustomDataTypes}
          />

          <AiAgentTestModal
            inputs={this.state.crew_inputs}
            agents={this.state.nodes.map((node) => node.data.metadata)}
            customDataTypes={this.state.crew_custom_data_types}
            processType={PROCESS_TYPE_TO_NUMBER[this.state.processType]}
            managerAgent={this.state.managerAgent}
            projectId={this.props.sd.project.id}
            actionName={this.state.actionName}
            isOpen={this.state.showTestModal}
            onClose={this.handleCloseTestModal}
          />
          <CloseConfirmationModal
            itemName={this.state.actionName}
            closeType={"AI Agent"}
            triggerModal={this.props.showModal}
            isLoading={this.state.isSaveDisabled}
            updateAndCloseHandler={() => this.formRef.current?.submit()}
            closeWithoutSaveHandler={() => {
              this.props.setShowModal(false);
              this.closeDataSource();
            }}
            cancel={() => {
              this.props.setNextCallbackFunction();
              this.props.setShowModal(false);
            }}
          />
          <DeleteModal
            itemName={this.state.actionToDelete?.name || ""}
            triggerModal={this.state.isDeleteActionModalVisible}
            deleteItem={this.deleteAIAgentAction}
            deleteType={"AI Agent"}
            closeModal={() => {
              this.setState({
                isDeleteActionModalVisible: false,
                actionToDelete: undefined
              });
            }}
          />
        </Form>
        <KModal
          className="ai-agent-fixes-applied-modal"
          header="Agents Fixed"
          showModal={this.state.showFixesAppliedModal}
          closeModal={() => {
            try {
              this.setState({ showFixesAppliedModal: false });
            } catch (e) {
              console.error("Error closing fixes modal:", e);
            }
          }}
          footer={
            <KModalFooter
              submitLabel="Save agent"
              onSubmit={() => {
                this.setState({ showFixesAppliedModal: false });
                this.saveAction();
              }}
            >
              <KuikaButton
                type="secondary"
                color="neutral"
                size="md"
                uppercase
                onClick={() => {
                  this.setState({ showFixesAppliedModal: false, rightPanelTab: "chat" }, () => {
                    // Use setTimeout to ensure the component is fully rendered before focusing
                    setTimeout(() => {
                      try {
                        this.chatbotRef.current?.focusInput();
                      } catch (e) {
                        console.error("Error focusing chatbot input:", e);
                      }
                    }, 100);
                  });
                }}
              >
                Review fixes
              </KuikaButton>
            </KModalFooter>
          }
        >
          <p>The agents have been fixed. Please review the changes. Or proceed with saving the agent.</p>
        </KModal>
        <ConfigBraveSearchSettings
          editingBraveSearchId={this.state.mcpConfigModalVisibility?.braveSearchSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("braveSearchSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.braveSearchSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigDropboxSettings
          editingDropboxId={this.state.mcpConfigModalVisibility?.dropboxSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("dropboxSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.dropboxSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigSlackSettings
          editingSlackId={this.state.mcpConfigModalVisibility?.slackSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("slackSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.slackSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGithubSettings
          editingGithubId={this.state.mcpConfigModalVisibility?.githubSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("githubSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.githubSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGoogleMcpSettings
          editingGoogleMcpId={this.state.mcpConfigModalVisibility?.googleMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("googleMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.googleMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGoogleMapMcpSettings
          editingGoogleMcpMapId={this.state.mcpConfigModalVisibility?.googleMapMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("googleMapMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.googleMapMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigJiraMcpSettings
          editingJiraMcpId={this.state.mcpConfigModalVisibility?.jiraMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("jiraMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.jiraMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigYoutubeMcpSettings
          editingYoutubeMcpId={this.state.mcpConfigModalVisibility?.youtubeMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("youtubeMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.youtubeMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigTrelloMcpSettings
          editingTrelloMcpId={this.state.mcpConfigModalVisibility?.trelloMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("trelloMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.trelloMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigOffice365McpSettings
          editingOffice365McpId={this.state.mcpConfigModalVisibility?.office365McpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("office365McpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.office365McpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigFirecrawlMcpSettings
          editingFirecrawlMcpId={this.state.mcpConfigModalVisibility?.firecrawlMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("firecrawlMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.firecrawlMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigApifySettings
          editingApifyId={this.state.mcpConfigModalVisibility?.apifySettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("apifySettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.apifySettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <AIAgentMcpModal
          header={mcpToolDefinition ? mcpToolDefinition.displayName || mcpToolDefinition.name : "Tool Configuration"}
          mcpTool={mcpTool}
          showModal={false}
          closeModal={() => {
            this.setState({ mcpModalIndexes: undefined });
          }}
          commonSettings={this.props.sd.commonSettings}
          isLoading={this.state.isSaveDisabled}
          handleSubmit={(mcpTool) => {
            const nodes = _.cloneDeep(this.state.nodes);
            const toolNode = nodes.find((node) => node.id === this.state.mcpModalIndexes?.nodeId);
            const tool = toolNode?.data.metadata.tools?.find((_tool, i) => i === this.state.mcpModalIndexes?.toolIndex);
            if (!toolNode || !tool) return;
            tool.settingsId = mcpTool.settingsId;
            this.setState({ nodes, mcpModalIndexes: undefined }, () => {});
          }}
          handleOpenConfigModal={(mcpTool) => {
            if (!mcpTool.mcpConfigName) return;
            this.updateMcpModalVisibility(mcpTool.mcpConfigName, true, mcpTool.settingsId);
          }}
        />
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return true;
  };
}

const mapStateToProps = (state: AppState) => ({
  showModal: state.unsavedChangesModal.showModal,
  nextCallback: state.unsavedChangesModal.nextCallback
});

const mapDispatchToProps = (dispatch) => ({
  setShowModal: (showModal: boolean) => dispatch(setShowModal(showModal, null)),
  setNextCallbackFunction: (cb?: () => void) => dispatch(setNextCallbackFunction(cb))
});

const createAIAgentAction = connect(
  mapStateToProps,
  mapDispatchToProps
)(withSD<ICreateAIAgentActionProps>(CreateAIAgentAction));
export { createAIAgentAction as CreateAIAgentAction };
